import React, { useState, useEffect, useCallback, useRef } from "react"; // Import React and useState
// import { GoogleMap, LoadScript } from '@react-google-maps/api';
import { useNavigate, useParams } from "react-router-dom";
import { useMemo } from "react";
import { ButtonWhite } from "../../Reusablecomponents/UIButtons";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import {
  Card,
  Col,
  Row,
  Badge,
  Space,
  Divider,
  Modal,
  Input,
  Select,
  DatePicker,
  Form,
  List,
  Button,
  Avatar,
  Typography,
  Tabs,
  message,
  Dropdown,
  Menu,
} from "antd";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { MdPhone } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { BiMessageRoundedDetail } from "react-icons/bi";
import { ReactComponent as Search } from "../../assets/images/search-svgrepo-com.svg";
import { CALL_API } from "../../Common/api";
import {
  FloatButtonContainer,
  FloatButton,
  Icon,
  Drawer,
  DrawerHeader,
  DrawerContent,
  Column,
  ColumnHeader,
  ColumnData,
  SearchInput,
  RowWrapper,
} from "./style";
import { ArrowUpRight, Truck, Filter } from "lucide-react"; // Using lucide-react for icons
import { useDispatch, useSelector } from "react-redux";
import MapComponent from "../../Reusablecomponents/MapComponent";
import styled from "styled-components";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import moment from "moment";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import TabPane from "antd/es/tabs/TabPane";
import { ReactComponent as Ellipse } from "../../assets/images/Ellipse.svg";
import { ReactComponent as Containerthree } from "../../assets/images/containerthree.svg";
import { ReactComponent as Onebyone } from "../../assets/images/onebyone.svg";
import { ReactComponent as RoundedIcon } from "../../assets/images/roundedicon.svg";
import { ReactComponent as RoundedIconthree } from "../../assets/images/roundediconthree.svg";
import { ReactComponent as Down } from "../../assets/images/down.svg";
import { ReactComponent as CloseBtn } from "../../assets/images/close_btn.svg";
import { ReactComponent as Lefticon } from "../../assets/images/leftdownoutlined.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/phonesvg.svg";
import { ReactComponent as ChatIconrounded } from "../../assets/images/chat-roundicon.svg";
import { ReactComponent as TruckIcon } from "../../assets/images/truck.svg";
import { ReactComponent as Filterpopup } from "../../assets/images/filterpopup.svg";
import { ReactComponent as PrimaryActive } from "../../assets/images/PrimaryActive.svg";
import { ReactComponent as Add } from "../../assets/images/Buttons.svg";
import { ReactComponent as Line } from "../../assets/images/Line 1241.svg";
import { WrapperBox } from "../Operations/Fuelentry/Consignment Operation/Consignment1";
import dayjs, { Dayjs } from "dayjs";
import UIModal from "../../Reusablecomponents/UIModal";
import { ReactComponent as Chat } from "../../assets/images/Chat.svg";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import { ReactComponent as Indicator } from "../../assets/images/Indicator.svg";
import { ReactComponent as DrawercloseIcon } from "../../assets/images/drawercloseicon.svg";
import { ReactComponent as SearchIcon } from "../../assets/images/searchicon.svg";
import {
  EventType,
  ContainerConsignmentEvents,
  ContainerConsignmentExportEvents,
  ShipmentType,
  shipmentType,
  AIConsignmentCollectionEvents,
  AIConsignmentDeliveryEvents,
  AIConsignmentCombinedEvents,
  ContainerConsignmentEventsForCustom,
} from "../../Common/constant";
import {
  setCompanyList,
  setDeviceList,
  setRouteList,
  setTripMonitorData,
  setVehicleLists,
} from "../../Redux/AuthSlice";
import mapboxgl from "mapbox-gl";

let mapboxglprop = mapboxgl;
mapboxgl.accessToken =
  "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";

// Chart.js registration removed
const HomeContainer = styled.div`
  .ant-card .ant-card-head {
    border-bottom: none !important;
  }
  .search-input {
    background-color: rgb(241, 241, 241) !important;
  }
  .MapboxWrap_one {
    width: 100% !important;
    height: calc(100vh - 100px) !important;
  }
  .mapbox_container_two {
    width: 100% !important;
    height: 100% !important;
  }
  @media (min-width: 320px) and (max-width: 426px) {
    .MapboxWrap_one {
      width: 100% !important;
      height: 100% !important;
    }
    .mapbox_container_two {
      width: 100% !important;
      height: 100% !important;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .ant-row {
      flex-wrap: nowrap !important;
    }
  }
  @media (min-width: 320px) and (max-width: 426px) {
    .scrollable_container {
      overflow: scroll !important;
    }
  }
  .drawerfor_vehicles {
    height: 84% !important;
  }
  @media (min-width: 320px) and (max-width: 426px) {
    .trip_wrapper {
      display: flex;
      flex-direction: column;
    }

    .container_for_trip {
      margin-top: 120px;
      width: 380px;
      width: 90% !important;
      margin-right: 850px;
      top: 40px;
      left: 19px !important;
      border-radius: 20px;
      // height: 600px!important;
      overflow-y: scroll;
      padding: 20px;
      z-index: 9999;
      max-height: 450px !important;
    }

    .svg_search {
      display: none;
    }

    .MapboxWrap {
      height: 50% !important;
    }
    .my_custom_row {
      /* overflow: scroll !important; */
    }
    .BUTTON_trackrightai {
      display: flex;
      flex-direction: column !important;
      margin-bottom: 10px;
    }
    .drawerfor_vehicles {
      background-color: red !important;
      margin-top: 120px;
      width: 400px;
      margin-right: 61px !important;
      border-radius: 20px;
      height: 650px;
      padding: 15px;
      overflow-y: scroll;
      z-index: 9999;
    }
    .mapboxgl-map {
      height: 50% !important;
    }
  }

  .MapboxWrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
  .recharts_tooltip_wrapper {
    padding: 2px 2px 2px 2px !important;
  }
  .Button-Wrap {
    /* padding-bottom: 15px; */

    borderradius: 8;
    margintop: 32;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .float_button_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    zindex: 2;
  }
  .button-style {
    padding-right: 20px;
  }
  .ant-card .ant-card-body {
    padding: 0px !important;
  }
  .ant-card .ant-card-head {
    padding: 0px 10px;
  }
`;
const Newbox = styled.div`
  @media (min-width: 768px) and (max-width: 2560px) {
    .new_container_three_vehicle {
      max-width: 100% !important;
    }
  }

  @media (min-width: 320px) and (max-width: 426px) {
    .float_button_continer_for_ArrowUpRight {
      position: fixed;
      top: 280px !important;
      z-index: 9999;
      left: 83.5% !important;
    }
  }

  @media (min-width: 320px) and (max-width: 426px) {
    .new_container_vehicle {
      height: auto !important;
    }
    .container_two_vehicles {
      display: flex !important;
      flex-wrap: wrap !important;
      height: auto !important;
    }

    .mapboxgl-map {
      height: 50% !important;
    }
    .Inputval_field {
      border-bottom: none !important;
      background-color: rgb(241, 241, 241) !important;
    }
    .my_custom_row {
      overflow: scroll !important;
    }
    .BUTTON_trackrightai {
      display: flex;
      flex-direction: column !important;
      margin-bottom: 20px;
      background-color: red !important;
    }
    .drawerfor_vehicles {
      margin-top: 120px;
      width: 400px;
      /* margin-right: 70px !important; */
      top: 45px !important;
      margin-right: 35px !important;
      border-radius: 20px;
      height: 650px;
      padding: 15px;
      overflow-y: scroll;
      z-index: 9999;
      /* height: 84% !important; */
      height: 450px !important;
      background-color: white !important;
    }
    .MapboxWrap {
      height: 50% !important;
    }

    .search_input {
      display: none;
    }
  }
  @media (min-width: 1440px) and (max-width: 2560) {
    .drawerfor_vehicles {
      width: 30% !important;
      height: 70% !important;
      background-color: white !important;
    }
  }

  @media (min-width: 320px) and (max-width: 465px) {
    .drawerfor_vehicles {
      width: 85% !important;
      height: 64% !important;
      background-color: white !important;
    }
    .conatiner_drawer_header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .Inputval_field {
      margin-left: 30px;
      padding-left: 25px;
      border-bottom: 1px solid gray;
      width: 100% !important;
      margin-left: 0px;
      margin-top: 20px;
      border-bottom: none;
      background-color: rgb(241, 241, 241) !important;
    }
  }
  &.container_vehiclewidgets {
    height: 100vh;
  }
  .mapboxgl-ctrl-bottom-right .mapboxgl-ctrl {
    display: none !important;
  }

  .videts_container_s {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 16px;
  }
  .donut_chart_conatiner {
  }
  .donut_chart_conatinerone {
    position: relative;
  }
  .donut_chart_conatinertwo {
    position: absolute;
    right: 45%;
    top: 24%;
  }
  .vehicle_labels {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .container_widgets_sevenn {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: blue;
    flex-direction: column;
  }
  .container_ten {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 46vh;
  }
  .container_eleven {
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: space-between;
  }
  .conatiner_twelve {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    flexshrink: 0;
    display: block;
  }
  .container_fourteen {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .conatainer_four {
    display: flex;
    background-color: green;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }

  .container_consingments_cards {
    margin-top: 10px;
  }
  p {
    color: rgb(95, 109, 140);
  }
  svg rect[fill="#F20000"] {
    display: none !important;
  }

  .search_icon {
    color: rgb(95, 109, 140);
    font-size: 18px;
  }
  .container_for_kpi {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .container_for_kp {
    display: flex;
    align-items: center;
    gap: 25px;
    margin: 0px 0px 0px 0px;
  }
  .container_for_kp_popup {
    display: flex;
    align-items: center;
    gap: 25px;
    margin: 20px 0px 0px 0px;
    border-top: 1px solid rgb(231, 231, 237);
  }
  .container_for_kpi_filter {
    display: flex;
    justify-content: space-between;
    padding-right: 40px;
    margin: 0px 0px 30px 0px;
  }

  .ant-select .ant-select-selector {
    border: 1px solid #ccc !important;
    border-radius: 18px !important;
  }
  .ant-avatar-square {
    border-radius: 50% !important;
    cursor: pointer;
    background-color: rgb(220, 237, 223);
    padding: 20px 20px 20px 20px;
  }
  .Filter_for_clickablerow {
    font-size: 18px !important;
    font-weight: 600 !important;
  }
  .Filter_for_Result {
    font-size: 18px;
    color: rgb(44, 150, 61);
  }
  .select_label {
    color: rgb(95, 109, 140);
    margin-bottom: 5px;
  }
  .select_container {
    display: flex;
    flex-direction: column;
    margin: 30px 0px 0px 0px;
  }
  .and_clear_btn.ant-btn {
    padding: 9px 24px !important;
    color: white !important;
    background-color: rgb(44, 150, 61) !important;
    border-radius: 19px !important;
    border: none !important;
    font-size: 17px;
  }
  .table_forkpi_page {
    margin: 30px 0px;
  }
  .popup_container_for_forms {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
  }
  .modifying_kpi {
    border-top: 1px solid rgb(231, 231, 237);
    font-size: 17px;
    font-weight: 400;
  }

  .container_for_kpi_filter {
    width: 70%;
    gap: 10px;
    align-items: center;
    align-self: flex-end;
  }
  .ant-tabs-nav .ant-tabs-nav-more {
    position: none;
    background: none;
  }
  .container_one {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .container_two {
    display: flex;
    align-items: center;
    gap: 13px;
    margin-top: 13px;
  }
  .container_five {
    display: flex;
    align-items: center;
  }
  .container_four {
    margin: 15px 0px 15px 0px;
    display: flex;
    flex-direction: column;
  }
  .container_four > p {
    margin: 15px 0px 12px 0px;
    align-items: center;
  }
  .container_seven {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .container_eight {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .Consignment_p {
    font-size: 18px;
    margin: 18px 11px 15px 5px;
    font-weight: 500;
  }
  .container_forten {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .container_seventeen {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .container_fordetailstab {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0px;
  }
  .Consign_Code {
    color: #363636;
    font-weight: 300;
    font-style: italic;
    font-size: 12px;
  }
  .Details {
    color: #5f6d8c;
    font-weight: 400;
    font-size: 14px;
  }
  .Consign_Code_forsubtab {
    width: 35%;
    color: #363636;
  }
  .container_fifteen {
    display: flex;
    background-color: rgb(235, 247, 237);
    padding: 5px 5px 4px 4px;
    border-radius: 10px;
    width: 100%;
    flex-wrap: wrap;
  }
  .container_forhistorystab {
    display: flex;
    flex-direction: column;
    width: 50%;
    background-color: "";
  }
  .Drivername_forhistorytab {
    margin: 0px 7px 14px 7px;
    font-weight: 400;
    font-size: 16px;
    color: #363636;
  }
  .Driver_forhistorytab {
    margin: 14px 7px 14px 7px;
    font-weight: 400;
    font-size: 14px;
    color: #5f6d8c;
  }
  .vertical-dashed-line {
    position: absolute;
    left: 27px; /* Adjust based on icon's horizontal center */
    top: 40px; /* Start just below first icon */
    height: calc(100% - 80px); /* Adjust based on number of items */
    width: 1px;
    border-left: 1px dashed #d0d5dd;
    z-index: 0;
  }

  .container_detailsfornineteen {
    display: flex;
    width: 100%;
    align-items: center;
    margin: 7px 0px 0px 4px;
  }
  .container_seven_fordetils {
    width: 10%;
  }
  .container_seven_fordetilss {
    width: 50%;
  }
  .containerfor_mapintegration {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .containerfor_mapintegration_submenu {
    display: flex;
    width: 80%;
    justify-content: flex-end;
    gap: 0px;
  }
  .ant-select-selector {
    border-radius: 6px !important;
    border: none !important;
    border-bottom: 2px solid #e7e7ed !important;
  }
  .close_btn_fordrawer {
    position: relative;
    left: 22px;
  }
  .trips_container {
    align-items: center;
    font-size: 18px;
    margin-top: px;
    font-weight: 500;
    color: black;
  }
  .ant-tabs-nav {
    border-bottom: none !important;
  }
  p {
    margin-bottom: 5px 0px 3px 0px;
  }
  .container_forvehicle {
    margin: 6px 5px 7px 5px;
  }
  .freecontainer_vehicle {
    display: flex;
    gap: 10px;
  }
  .freecontainer_chaticon {
    display: flex;
    gap: 10px;
    justify-content: space-between;
  }
  .container_forvehicles {
    display: flex;
    gap: 10px;
  }
  .container_forvehicles > p {
    font-size: 18px;
  }
  .detail_row {
    display: flex;
    width: 100%;
  }
  .detail_label {
    width: 50%;
  }
  .detail_value {
    width: 50%;
  }
  .detail_roww {
    background-color: rgb(235, 247, 237);
    padding: 9px 4px 5px 10px;
    border-radius: 19px;
  }
  .detail_item {
    display: flex;
    width: 100%;
    justify-content: space-between;
    background-color: rgb(235, 247, 237);
  }
  .detail_labell {
    width: 50%;
  }
  .detail_value {
    width: 50%;
  }
  .close_btnfordrawer {
    margin-bottom: 25px;
    // margin-left: 15px;
    cursor: pointer;
  }
  .float_button_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .kpi_alterts_table {
    margin: 15px 0px 20px 0px;
  }
  .trip_wrapper {
    display: flex;
    background-color: "";
    width: 100%;
  }
  .trip_content {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 12px;
  }
  .search-input {
    width: 100%;
    border-radius: 18px;
  }
  .trip_drawer {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
  }
  .trip_heading {
    font-size: 24px;
    font-weight: 600;
    margintop: 10px;
  }
  .drawer_close_icon {
    margin-right: 0px;
  }

  .float_button_continer_for_ArrowUpRight {
    position: fixed;
    top: 170px;
    left: 18%;
    z-index: 1000;
  }
  @media (min-width: 1023px) and (max-width: 1025px) {
    .float_button_continer_for_ArrowUpRight {
      position: fixed;
      top: 170px;
      left: 27%;
      z-index: 1000;
    }
  }

  @media (min-width: 427px) and (max-width: 768px) {
    .float_button_continer_for_ArrowUpRight {
      position: fixed;
      top: 210px;
      z-index: 9999;
      left: 29%;
    }
  }

  .ant-tabs-nav .ant-tabs-nav-more {
    display: none;
  }
  .vehicle_for_dognutchart {
    /* font-size: 19px;
  margin: 0px 0px 0px 0px;
  font-weight: "bold", */
  }
`;
const ListWrap = styled.div`
  .delivery-card {
    margin-bottom: 16px;
    border-radius: 8px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  }

  .header {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .name {
    flex-grow: 1;
    font-size: 16px;
  }

  .status-btn {
    background-color: #1677ff;
  }

  .completed {
    color: #1677ff;
    font-size: 14px;
  }

  .task-list {
    margin-top: 12px;
  }

  .task-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .task-item:last-child {
    border-bottom: none;
  }

  .task-content {
    flex-grow: 1;
    margin-left: 8px;
  }

  .task-title {
    font-size: 14px;
    display: block;
  }

  .task-time {
    font-size: 12px;
    color: gray;
  }

  .task-location {
    font-size: 12px;
    color: #1890ff;
  }

  .arrow-icon {
    color: #52c41a;
    font-size: 16px;
  }
  .Consign_Code {
    font-size: 7px;
  }
`;

const mapContainerStyle = {
  width: "100vw",
  height: "100vh",
  // position: "relative", // Make the container relative so that the cards can be positioned absolutely inside it
};

const getTotalConsignments = async () => {
  try {
    const response = await CALL_API("GET", "get_total_consignments", {});
  } catch (error) {
    console.error("[getTotalConsignments] error -->", error);
  }
};

const getTotalKpiAlert = async () => {
  try {
    const response = await CALL_API("GET", "get_total_kpi_alerts", {});
  } catch (error) {
    console.error("[getTotalConsignments] error -->", error);
  }
};

const dataa = {
  datasets: [
    {
      data: [300, 200], // Example data
      backgroundColor: ["#006400", "#FF0000"], // Dark Green, Dark Blue, and Red
      hoverBackgroundColor: ["#006400", "#FF0000"], // Same hover colors
    },
  ],
  labels: [],
};

const vdataa = {
  datasets: [
    {
      data: [300, 200, 150, 100, 250, 180, 220], // Example data
      backgroundColor: [
        "#90EE90", // Light Green
        "#FF0000", // Red
        "#FFB6C1", // Light Pink
        "#ADD8E6", // Light Blue
        "#FFFFE0", // Light Yellow
        "#FFD700", // Dark Yellow
        "#006400", // Dark Green
      ], // Dark Green, Dark Blue, and Red
      hoverBackgroundColor: [
        "#90EE90", // Light Green
        "#FF0000", // Red
        "#FFB6C1", // Light Pink
        "#ADD8E6", // Light Blue
        "#FFFFE0", // Light Yellow
        "#FFD700", // Dark Yellow
        "#006400", // Dark Green
      ],
    },
  ],
  labels: [],
};

const cdata = {
  datasets: [
    {
      data: [300, 200, 150, 100, 250, 180, 220], // Example data for 7 sections
      backgroundColor: [
        "#ADD8E6", // Light Blue
        "#FFD700", // Dark Yellow
      ],
      hoverBackgroundColor: [
        "#ADD8E6", // Light Blue
        "#FFD700", // Dark Yellow
      ],
    },
  ],
  labels: ["Assigned", "Unassigned"],
};

const center = {
  lat: 20.5937, // Latitude for the center (India)
  lng: 78.9629, // Longitude for the center
};

const drawer = {
  Assigned: [
    {
      id: 1,
      driver: "Samuel johsaph (KCE605)",
      pickup: "pickup",
      time: "21 Aug 2024, 13:55",
      status: "Delever",
    },
  ],
  InProgress: [
    {
      id: 1,
      driver: "Samuel  (KCE605)",
      pickup: "pickup",
      time: "21 Aug 2024, 13:55",
      status: "Delevered",
    },
  ],
  Completed: [
    {
      id: 1,
      driver: "Samuel  (KCE605)",
      pickup: "pickup",
      time: "21 Aug 2024, 13:55",
      status: "completed",
    },
  ],
};

const vehicleDrawer = {
  Free: [
    {
      id: 1,
      vName: "KCE2345",
      driver: "Samuel Josephson",
      phone: "07234789",
    },
  ],
  Busy: [
    {
      id: 1,
      vName: "KCE2345",
      driver: "Samuel Josephson",
      phone: "07234789",
    },
  ],
  InActive: [
    {
      id: 1,
      vName: "KCE2345",
      driver: "Samuel Josephson",
      phone: "07234789",
    },
  ],
};

const Home = () => {
  const dispatch = useDispatch();

  // Initialize selectedReport at the top before any usage
  const [selectedReport, setSelectedReport] = useState("TrackRightAI");

  const { tripId } = useParams();
  const { Text } = Typography;
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerOpenOne, setDrawerOpenone] = useState(false);
  const [tripPopupOpen, setTripPopupOpen] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState(0);
  const [selectedVehicleTab, setSelectedVehicleTab] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [vehicleSearch, setVehicleSearch] = useState("");
  const [truckDrawerOpen, setTruckDrawerOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [kpiCount, setKpiCount] = useState([]);
  const [consignmentCount, setConsignmentCount] = useState([]);
  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [vehicleEventCount, setVehicleEventCount] = useState([]);
  const [tripDetails, setTripDetails] = useState([]);
  const [filterCount, setFilterCount] = useState(0);
  const [form] = Form.useForm();
  const { Option } = Select;
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const subscriptionList = useSelector(
    (state) => state?.authTracking?.subscriptionList,
  );
  const [panelOpen, setPanelOpen] = useState(false);
  const [pinlocation, setLocationDetialsProps] = useState([]);
  const [routeDetails, setRouteDetails] = useState([]);
  const [singleTripPanel, setsingleTripPanel] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  const [containerTruck, setContainerTruck] = useState(false);
  const [vehicles, setVehicles] = useState(false);
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const [usAssignedTrips, setUnAssignedTrips] = useState([]);
  const [consignmentMap, setConsignmentMap] = useState({});
  const [tabId, setTabId] = useState(0);
  const [singleTrip, setSingleTrip] = useState([]);
  const [singleConsignment, setSingleConsignment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [singleConsignor, setSingleConsignor] = useState({});
  const [singleHistory, setSingleHistory] = useState([]);
  const [showCharts, setShowCharts] = useState(false); //toggle state
  const [formValues, setFormValues] = useState({});
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const homeAIRead = useMemo(
    () => hasPermission("AI_HME", "R"),
    [reduxPermissions],
  );
  const homeAIPRead = useMemo(
    () => hasPermission("AIPLS_HME", "R"),
    [reduxPermissions],
  );
  const homeCargoRead = useMemo(
    () => hasPermission("CONT_HME", "R"),
    [reduxPermissions],
  );
  const homeAIVehicle = useMemo(
    () => hasPermission("AI_HME", "VEH"),
    [reduxPermissions],
  );
  const homeAITrip = useMemo(
    () => hasPermission("AI_HME", "TRP"),
    [reduxPermissions],
  );
  const homeAIPVehicle = useMemo(
    () => hasPermission("AIPLS_HME", "VEH"),
    [reduxPermissions],
  );
  const homeAIPTrip = useMemo(
    () => hasPermission("AIPLS_HME", "TRP"),
    [reduxPermissions],
  );
  const homeCargoVehicle = useMemo(
    () => hasPermission("CONT_HME", "VEH"),
    [reduxPermissions],
  );
  const homeCargoTrip = useMemo(
    () => hasPermission("CONT_HME", "TRP"),
    [reduxPermissions],
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!mapRef.current && !isMobile) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/mapbox/streets-v11",
        center: [37.9062, 0.0236], // Centered on Africa
        zoom: 10,
      });

      mapRef.current.resize();

      const handleResize = () => mapRef.current?.resize();
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const [vehicleList, setVehicleList] = useState([]);
  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      dispatch(setCompanyList(data?.companies || []));
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      const loggedInCompany = userInfo?.ECTSCompId || "";
      const companyVehicles =
        data?.companies?.filter(
          (vehicle) => vehicle.FAgentGUID === loggedInCompany,
        ) || [];
      setVehicleList(companyVehicles);
      dispatch(setVehicleLists(companyVehicles));
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const fetchAllRoute = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllRoute");
      dispatch(setRouteList(data?.companies || []));
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllDevice = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllDevice");
      const devices = data?.companies || [];
      dispatch(setDeviceList(devices));
      // Extract FGUIDs from devices
      const fguids = devices.map((d) => d.FGUID).filter(Boolean);
      // If we have FGUIDs, call trip monitor
      if (fguids.length > 0) {
        fetchTripMonitor(fguids);
      }
    } catch (error) {
      console.error("[fetchAllDevice] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchTripMonitor = useCallback(async (aDevices) => {
    try {
      const { data } = await CALL_API("POST", "container/tripMonitorList", {
        aDevices,
      });
      dispatch(setTripMonitorData(data?.Result || []));
    } catch (error) {
      console.error("[fetchTripMonitor] error:", error);
    }
  }, []);
  useEffect(() => {
    fetchAllCompany();
    fetchAllVehicle();
    fetchAllRoute();
    fetchAllDevice();
    fetchTripMonitor();
  }, []);
  const vehicleOptions = vehicleList.map((item) => ({
    value: item.FGUID,
    label: item.FVehicleName,
    vehicleTypeId: item.FVehicleTypeID,
  }));
  const navigate = useNavigate(); // Initialize useNavigate
  const handleCellClick = (index) => {
    const clickedLabel = charts.consignment.labels[index];
    handleLabelClick1(clickedLabel);
  };

  //Assigned unassigned tab navigation  function on Trackright AI
  const handleLabelClick1 = (clickedLabel) => {
    setShowCharts(!showCharts);
    if (selectedReport === "TrackRightAI") {
      if (clickedLabel === "Assigned") {
        const todayDate = dayjs().format("YYYY-MM-DD");

        navigate("/consignmentAI", {
          state: {
            activeTab: "label1",
            date: formValues?.date,
            dates: todayDate,
          },
        });
      } else if (clickedLabel === "Unassigned") {
        const todayDate = dayjs().format("YYYY-MM-DD");
        navigate("/consignmentAI", {
          state: {
            activeTab: "label2",
            date: formValues?.date,
            dates: todayDate,
          },
        });
      }
    }
    if (selectedReport === "TrackrightAIPlus") {
      if (clickedLabel === "Assigned") {
        const todayDate = dayjs().format("YYYY-MM-DD");

        navigate("/Consignment1", {
          state: {
            activeTab: "label1",
            date: formValues?.date,
            dates: todayDate,
          },
        });
      } else if (clickedLabel === "Unassigned") {
        const todayDate = dayjs().format("YYYY-MM-DD");

        navigate("/Consignment1", {
          state: {
            activeTab: "label2",
            date: formValues?.date,
            dates: todayDate,
          },
        });
      }
    } else if (selectedReport === "ContainerTracking") {
      navigate("/tripMonitoring");
    }
  };

  const handleKpiLabelClick = (label, date) => {
    if (selectedReport === "TrackRightAI") {
      navigate("/AIkpi report", { state: { label, date } });
    } else if (selectedReport === "ContainerTracking") {
      navigate("/containerReports", { state: { tab: "2", label } });
    } else if (selectedReport === "TrackrightAIPlus") {
      navigate("/reports/kpi report", { state: { label, date } });
    }
    // Add more conditions for other dashboards if needed
  };

  // function to handle chart slice click
  const handleCellClickVehicle = (index) => {
    const clickedLabel = charts.vehicle.labels[index];
    handleVehicleClick(clickedLabel);
  };
  const handleVehicleClick = (label) => {
    if (selectedReport === "TrackRightAI") {
      if (label === "Started") {
        navigate("/consignmentAI", {
          state: { stage: 1, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Pickup Journey Started") {
        navigate("/consignmentAI", {
          state: { stage: 13, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Arrived Pickup Point") {
        navigate("/consignmentAI", {
          state: { stage: 17, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Delivery Journey Started") {
        navigate("/consignmentAI", {
          state: { stage: 13, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Delivery journey Started") {
        navigate("/consignmentAI", {
          state: { stage: 18, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Arrived at Pickup Point") {
        navigate("/consignmentAI", {
          state: { stage: 20, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Reached Delivery Point") {
        navigate("/consignmentAI", {
          state: { stage: 17, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Reached Delivery point") {
        navigate("/consignmentAI", {
          state: { stage: 14, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Return Journey Started") {
        navigate("/consignmentAI", {
          state: { stage: 18, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Returned To Base") {
        navigate("/consignmentAI", {
          state: { stage: 14, shipmentTypes: formValues?.shipment },
        });
      } else if (label === "Finished") {
        navigate("/consignmentAI", {
          state: { stage: 16, shipmentTypes: formValues?.shipment },
        });
      }
    } else if (selectedReport === "ContainerTracking") {
      navigate("/tripMonitoring");
    } else if (selectedReport === "TrackrightAIPlus") {
      if (label === "Started") {
        navigate("/Consignment1", { state: { stage: 1 } });
      } else if (label === "Accepted") {
        navigate("/Consignment1", { state: { stage: 0 } });
      } else if (label === "Arrived PickUp Point") {
        navigate("/Consignment1", { state: { stage: 2 } });
      } else if (label === "Loading Started") {
        navigate("/Consignment1", { state: { stage: 3 } });
      } else if (label === "Loading Completed") {
        navigate("/Consignment1", { state: { stage: 4 } });
      } else if (label === "Journey Started") {
        navigate("/Consignment1", { state: { stage: 5 } });
      } else if (label === "Reached Delivery Point") {
        navigate("/Consignment1", { state: { stage: 6 } });
      } else if (label === "Offloading Started") {
        navigate("/Consignment1", { state: { stage: 7 } });
      } else if (label === "Offloading Completed") {
        navigate("/Consignment1", { state: { stage: 8 } });
      } else if (label === "Return Journey Started") {
        navigate("/Consignment1", { state: { stage: 9 } });
      } else if (label === "Returned to Base") {
        navigate("/Consignment1", { state: { stage: 10 } });
      } else if (label === "Finished") {
        navigate("/Consignment1", { state: { stage: 11 } });
      }
    }
  };

  const handleLabelClick = (label) => {
    if (label === "Started") {
      navigate("/Consignment1", { state: { stage: 1 } });
    } else if (label === "Arrived_PickUp_Point") {
      navigate("/Consignment1", { state: { stage: 2 } });
    } else if (label === "Loading_Started") {
      navigate("/Consignment1", { state: { stage: 3 } });
    } else if (label === "Loading_Completed") {
      navigate("/Consignment1", { state: { stage: 4 } });
    } else if (label === "Journey_started") {
      navigate("/Consignment1", { state: { stage: 5 } });
    } else if (label === "Reached_Delivery_Point") {
      navigate("/Consignment1", { state: { stage: 6 } });
    } else if (label === "Offloading_Started") {
      navigate("/Consignment1", { state: { stage: 7 } });
    } else if (label === "Offloading_Completed") {
      navigate("/Consignment1", { state: { stage: 8 } });
    } else if (label === "Return_journey_started") {
      navigate("/Consignment1", { state: { stage: 9 } });
    } else if (label === "Returned_to_base") {
      navigate("/Consignment1", { state: { stage: 10 } });
    } else if (label === "Finished") {
      navigate("/Consignment1", { state: { stage: 11 } });
    }
  };

  //TrackrightAI Chart API's
  const [TrackrightAIKPI, setTrackrightAIKPI] = useState([]);
  const [AIConsignmentsData, setAIConsignmentsData] = useState([]);
  const [AIEventData, setAIEventData] = useState([]);
  const fetchAIKPI = async () => {
    try {
      const { data } = await CALL_API("POST", "AI/getKPIAIcount", {
        mcId: userInfo?.MCID,
        startDate:
          dayjs(formValues?.date).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        endDate:
          dayjs(formValues?.date).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        code: "",
        recName: formValues?.Consignee,
        custName: formValues?.consignor,
        transporter: formValues?.transporter,
        regNo:
          vehicleList.find((v) => v.FGUID === formValues?.vehicle)
            ?.FVehicleName || "",
      });
      setTrackrightAIKPI(data?.[0]);
    } catch (error) {
      console.error("Error fetching Container KPI:", error);
      setTrackrightAIKPI();
    }
  };

  // const fetchAIConsignmentData = async () => {
  //   try {
  //     const { data } = await CALL_API(
  //       "POST",
  //       "AI/getAssignUnassignConsignment",
  //       {
  //         mcId: userInfo?.MCID,
  //         startDate:
  //         dayjs(formValues?.date).format("YYYY-MM-DD") ||
  //         moment(new Date()).format("YYYY-MM-DD"),
  //         endDate:
  //         dayjs(formValues?.date).format("YYYY-MM-DD") ||
  //         moment(new Date()).format("YYYY-MM-DD"),
  //         cust: formValues?.consignor || 0,
  //         shipper: formValues?.transporter || 0,
  //         receiver: formValues?.Consignee || 0,
  //         tripType: formValues?.tripType || 0,
  //         vehid: formValues?.VehId || 0,
  //         // ShipmentType: formValues?.shipment || "2",
  //       }
  //     );
  //     setAIConsignmentsData(data);
  //   } catch (error) {
  //     console.error("Error fetching Seal Data:", error);
  //     setAIConsignmentsData();
  //   }
  // };
  const fetchAIConsignmentData = async () => {
    try {
      const { data } = await CALL_API(
        "POST",
        "AI/getAssignUnassignConsignment",
        {
          mcId: userInfo?.MCID,
          startDate:
            dayjs(formValues?.date).format("YYYY-MM-DD") ||
            moment(new Date()).format("YYYY-MM-DD"),
          endDate:
            dayjs(formValues?.date).format("YYYY-MM-DD") ||
            moment(new Date()).format("YYYY-MM-DD"),
          cust: formValues?.consignor || 0,
          shipper: formValues?.transporter || 0,
          receiver: formValues?.Consignee || 0,
          tripType: formValues?.tripType || 0,
          vehid: formValues?.vehicle || "",
          ShipmentType: formValues?.shipment || "0",
        },
      );

      const raw = data?.[0] || {};
      const converted = {
        Assigned: Number(raw.Assigned || 0),
        Unassigned: Number(raw.Unassigned || 0),
      };
      setAIConsignmentsData(converted);
    } catch (error) {
      console.error("Error fetching Seal Data:", error);
      setAIConsignmentsData({ Assigned: 0, Unassigned: 0 });
    }
  };

  const fetchAIEventData = async () => {
    const { data } = await CALL_API("POST", "AI/getVehicleEventsCount", {
      mcId: userInfo?.MCID,
      pickupDate:
        dayjs(formValues?.date).format("YYYY-MM-DD") ||
        moment(new Date()).format("YYYY-MM-DD"),
      vehId: formValues?.vehicle || "",
      driver: 0,
      cust: formValues?.consignor,
      shipper: formValues?.transporter,
      receiver: formValues?.Consignee,
      tripType: formValues?.tripType,
      shipmentType: formValues?.shipment || 0,
    });
    setAIEventData(data || []);
  };
  const hideErrorText = () => {
    document.querySelectorAll(".mapboxgl-ctrl-geolocate").forEach((el) => {
      if (el.innerText.includes("locations available")) {
        el.innerText = ""; // or el.style.display = 'none';
      }
    });
  };

  // Run it once and also on DOM changes
  hideErrorText();
  setInterval(hideErrorText, 1000); // retry if Mapbox re-renders

  //Container Chart API's
  const [containerKPI, setContainerKPI] = useState([]);
  const [sealData, setSealData] = useState([]);
  const [eventData, setEventData] = useState([]); // Array of { EventStatus, ConsignmentCount }
  const defaultKPI = { Resolved: 0, Unresolved: 0 };
  const defaultSeal = { assignedDevices: 0, unassignedDevices: 0 };

  const fetchContainerKPI = async () => {
    try {
      const { data } = await CALL_API("POST", "/container/getContainerKPI", {
        mcId: userInfo?.MCID,
        startDate:
          dayjs(formValues?.date).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        endDate:
          moment(formValues?.date).format("YYYY-MM-DD") ||
          moment(new Date()).format("YYYY-MM-DD"),
        code: "",
        recName: "",
        custName:
          consignerList.find((v) => v.ID === formValues?.consignor)?.Name || "",
        transporter:
          transporterList.find((v) => v.ID === formValues?.transporter)?.Name ||
          "",
        regNo:
          vehicleList.find((v) => v.FGUID === formValues?.vehicle)
            ?.FVehicleName || "",
      });

      setContainerKPI(data?.[0] || defaultKPI);
    } catch (error) {
      console.error("Error fetching Container KPI:", error);
      setContainerKPI(defaultKPI);
    }
  };

  const fetchSealData = async () => {
    try {
      const queryParams = new URLSearchParams({
        FAgentGUID: userInfo?.ECTSCompId || "",
        MCID: userInfo?.MCID,
        VehId: formValues?.vehicle || "",
        Cust: formValues?.consignor || 0,
        Shipper: formValues?.transporter || 0,
        Receiver: formValues?.Consignee || 0,
        TripType: formValues?.tripType || 0,
        ShipmentType: formValues?.shipment || 0,
      });

      const res = await CALL_API(
        "GET",
        `/container/getSealsForCompany?${queryParams.toString()}`,
      );
      setSealData(res?.data || defaultSeal);
    } catch (error) {
      console.error("Error fetching Seal Data:", error);
      setSealData(defaultSeal);
    }
  };

  const fetchEventData = async () => {
    const { data } = await CALL_API(
      "POST",
      "/container/getContainerEventsCount",
      {
        mcId: userInfo?.MCID,
        contVehId: formValues?.vehicle || "",
        cust: formValues?.consignor || 0,
        shipper: formValues?.transporter || 0,
        receiver: formValues?.Consignee || 0,
        tripType: formValues?.tripType || 0,
        ShipmentType: formValues?.shipment || 0,
      },
    );
    setEventData(data || []);
  };
  useEffect(() => {
    fetchAIKPI();
    fetchAIConsignmentData();
    fetchAIEventData();
    fetchContainerKPI();
    fetchSealData();
    fetchEventData();
  }, [formValues]);
  // Dummy Data
  //Trackright aI Vehicle events label function
  const safeAIEventData = Array.isArray(AIEventData) ? AIEventData : [];
  const selectedAiShipmenttype = Form.useWatch("shipment", form);
  const AIeventmapping =
    selectedAiShipmenttype === 2
      ? AIConsignmentCollectionEvents
      : selectedAiShipmenttype === 1
        ? AIConsignmentDeliveryEvents
        : AIConsignmentCombinedEvents;
  const AIeventLabels = AIeventmapping.map((e) => e.name);
  const AIeventCounts = AIeventmapping.map((e) => {
    const found = Array.isArray(AIEventData)
      ? AIEventData.find((d) => d.EventName === e.name)
      : null;
    return found ? found.ConsignmentCount : 0;
  });

  //Container tacking Event chart Label function
  // const safeEventData = Array.isArray(eventData) ? eventData : [];
  // const selectedShipmentType = Form.useWatch("shipment", form);

  // const eventMapping =
  //   selectedShipmentType === 2
  //     ? ContainerConsignmentExportEvents
  //     : ContainerConsignmentEvents;
  // // Build eventLabels and eventCounts so all labels are present, even if count is 0
  // const eventLabels = eventMapping.map((e) => e.name);
  // const eventCounts = eventMapping.map((e) => {
  //   const found = Array.isArray(eventData)
  //     ? eventData.find((d) => d.EventStatus === e.value)
  //     : null;
  //   return found ? found.ConsignmentCount : 0;
  // });

  // Extra events with default value 0 (when shipment type is not selected)

  // Determine which event mapping to use
  const selectedShipmentType = Form.useWatch("shipment", form);
  const eventMapping =
    selectedShipmentType === 2
      ? ContainerConsignmentExportEvents
      : selectedShipmentType === 1
        ? ContainerConsignmentEvents
        : [...ContainerConsignmentEventsForCustom];

  // Build event labels and counts
  const eventLabels = eventMapping.map((e) => e.name);
  const eventCounts = eventMapping.map((e) => {
    const found = Array.isArray(eventData)
      ? eventData.find((d) => d.EventName === e.name)
      : null;
    return found ? found.ConsignmentCount : 0;
  });
  const menu = (
    <Menu
      items={[
        subscriptionList.includes("AI_HME") &&
          homeAIRead && {
            key: "TrackRightAI",
            label: "TrackRight AI",
            onClick: () => {
              if (selectedReport === "TrackRightAI") setShowCharts(!showCharts);
              setSelectedReport("TrackRightAI");
            },
          },
        subscriptionList.includes("CONT_HME") &&
          homeCargoRead && {
            key: "ContainerTracking",
            label: "TrackRight AI Cargo",
            onClick: () => {
              if (selectedReport === "ContainerTracking")
                setShowCharts(!showCharts);
              setSelectedReport("ContainerTracking");
            },
          },
        subscriptionList.includes("AIPLS_HME") &&
          homeAIPRead && {
            key: "TrackrightAIPlus",
            label: "TrackRight AI+",
            onClick: () => {
              if (selectedReport === "TrackrightAIPlus")
                setShowCharts(!showCharts);
              setSelectedReport("TrackrightAIPlus");
            },
          },
      ].filter(Boolean)}
    />
  );

  const dummyData = {
    TrackRightAI: {
      kpi: {
        labels: ["Resolved", "Unresolved"],
        datasets: [
          {
            data: [TrackrightAIKPI.Resolved, TrackrightAIKPI.Unresolved],
            backgroundColor: ["#00BC13", "#F20000"],
          },
        ],
      },
      consignment: {
        labels: ["Assigned", "Unassigned"],
        datasets: [
          {
            data: [AIConsignmentsData.Assigned, AIConsignmentsData.Unassigned],
            backgroundColor: ["#0176EC", "#E4A400"],
          },
        ],
      },
      vehicle: {
        labels: AIeventLabels,
        datasets: [
          {
            data: AIeventCounts,
            backgroundColor: [
              "#3CAD43",
              "#ED0820",
              "#8606D6",
              "#FF7575",
              "#A78D66",
              "#F1B861",
              "#E4A400",
              "#00FF19",
            ],
          },
        ],
      },
    },
    ContainerTracking: {
      kpi: {
        labels: ["Resolved", "Unresolved"],
        datasets: [
          {
            data: [containerKPI.Resolved, containerKPI.Unresolved],
            backgroundColor: ["#00BC13", "#F20000"],
          },
        ],
      },
      consignment: {
        labels: ["Assigned", "Unassigned"],
        datasets: [
          {
            data: [sealData.assignedDevices, sealData.unassignedDevices],
            backgroundColor: ["#0176EC", "#E4A400"],
          },
        ],
      },
      vehicle: {
        labels: eventLabels,
        datasets: [
          {
            data: eventCounts,
            // backgroundColor: [
            //   "#FF6384",
            //   "#36A2EB",
            //   "#FFCE56",
            //   "#4BC0C0",
            //   "#9966FF",
            //   "#FF9F40",
            //   "#36A2EB",
            //   "#9966FF",
            // ],
            backgroundColor: [
              "#FF972F",
              "#ED0820",
              "#0E86FF",
              "#FF7575",
              "#5DFFBC",
              "#F1B861",
              "#3CAD43",
              "#1162B4",
              "#8606D6",
              "#2DDD93",
              "#A78D66",
              "#00FF19",
            ],
          },
        ],
      },
    },
    TrackrightAIPlus: {
      kpi: {
        labels: ["Resolved", "Unresolved"],
        datasets: [
          {
            data: [kpiCount?.Resolved, kpiCount?.Unresolved],
            backgroundColor: ["#00BC13", "#F20000"],
          },
        ],
      },
      consignment: {
        labels: ["Assigned", "Unassigned"],
        datasets: [
          {
            data: [
              Number(consignmentCount?.Assigned) || 0,
              Number(consignmentCount?.Unassigned) || 0,
            ],
            backgroundColor: ["#0176EC", "#E4A400"],
          },
        ],
      },
      vehicle: {
        labels: [
          "Started",
          "Arrived PickUp Point",
          "Loading Started",
          "Loading Completed",
          "Journey Started",
          "Reached Delivery Point",
          "Offloading Started",
          "Offloading Completed",
          "Return Journey Started",
          "Returned to Base",
          "Finished",
        ],
        datasets: [
          {
            data: [
              vehicleEventCount?.find((value) => value?.EventStatus === 1)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 2)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 3)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 4)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 5)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 6)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 7)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 8)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 9)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 10)
                ?.ConsignmentCount || 0,
              vehicleEventCount?.find((value) => value?.EventStatus === 11)
                ?.ConsignmentCount || 0,
            ],
            backgroundColor: [
              "#3CAD43",
              "#FF972F",
              "#ED0820",
              "#1162B4",
              "#0E86FF",
              "#8606D6",
              "#FF7575",
              "#2DDD93",
              "#5DFFBC",
              "#A78D66",
              "#F1B861",
              "#00FF19",
            ],
          },
        ],
      },
    },
  };

  const charts = dummyData[selectedReport];

  // Custom legends for different chart types
  const KpiLegend = ({ labels = [], data = [], colors = [] }) => (
    <div style={{ marginTop: 5 }}>
      {labels.map((label, index) => (
        <div
          key={label}
          onClick={() =>
            handleKpiLabelClick(
              label,
              dayjs(formValues?.date).toISOString() || dayjs(),
            )
          }
          style={{
            display: "flex",
            alignItems: "center",
            gap: 20,
            marginBottom: 6,
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: 14,
              height: 14,
              backgroundColor: colors[index],
              borderRadius: 2,
              flexShrink: 0,
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              lineHeight: "30px",
              width: "100%",
              fontSize: 14,
              color: "#5F6D8C",
            }}
          >
            {/* <span style={{ minWidth: 100 }}>{label}</span> */}
            <span>
              {label}: {data[index]}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
  const ConsignmentLegend = ({ labels = [], data = [], colors = [] }) => (
    <div style={{ marginTop: 5 }}>
      {labels.map((label, index) => (
        <div
          key={label}
          onClick={() => handleLabelClick1(label)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 20,
            marginBottom: 6,
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: 14,
              height: 14,
              backgroundColor: colors[index],
              borderRadius: 2,
              flexShrink: 0,
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              lineHeight: "30px",
              width: "100%",
              fontSize: 14,
              color: "#5F6D8C",
            }}
          >
            {/* <span style={{ minWidth: 100 }}>{label}</span> */}
            <span>
              {label}: {data[index]}
            </span>
          </div>
        </div>
      ))}
    </div>
  );

  const VehicleLegend = ({ labels, colors, values, side }) => {
    const mid = Math.ceil(labels.length / 2);
    const items = side === "left" ? labels.slice(0, mid) : labels.slice(mid);

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        {items.map((label, idx) => {
          const actualIndex = side === "left" ? idx : idx + mid;
          return (
            <div
              key={actualIndex}
              onClick={() => handleVehicleClick(label)}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 4, // Space between label rows
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  width: 12,
                  height: 12,
                  backgroundColor: colors[actualIndex],
                  borderRadius: 2,
                  marginRight: 6,
                  flexShrink: 0,
                }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: 176,
                  fontSize: 12,
                  color: "#5F6D8C",
                }}
              >
                <span>{label}</span>
                <span>{values[actualIndex]}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  const handleTrackClick = (tripId) => {
    window.open(
      `/tracklink/${tripId}?MCID=${userInfo?.MCID}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const [formData, setFormData] = useState({});
  const handleSubmit = (values) => {
    setDrawerOpen(false); // close drawer after submission
  };

  const resolved = kpiCount?.Resolved || 0;
  const unresolved = kpiCount?.Unresolved || 0;
  const total = resolved + unresolved;

  const isEmpty = total === 0;

  const actualData = [
    vehicleEventCount?.find((value) => value?.EventStatus === 1)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 2)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 3)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 4)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 5)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 6)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 7)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 8)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 9)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 10)
      ?.ConsignmentCount || 0,
    vehicleEventCount?.find((value) => value?.EventStatus === 11)
      ?.ConsignmentCount || 0,
  ];

  // check if all values are 0
  const isAllZero = actualData.every((val) => val === 0);

  const allLabels = [
    "Started",
    "Arrived_PickUp_Point",
    "Loading_Started",
    "Loading_Completed",
    "Journey_started",
    "Reached_Delivery_Point",
    "Offloading_Started",
    "Offloading_Completed",
    "Return_journey_started",
    "Returned_to_base",
    "Finished",
  ];

  const allColors = [
    "rgba(60, 173, 67, 1)",
    "rgba(237, 8, 32, 1)",
    "rgba(17, 98, 180, 1)",
    "rgba(14, 134, 255, 1)",
    "rgba(134, 6, 214, 1)",
    "rgba(255, 117, 117, 1)",
    "rgba(45, 221, 147, 1)",
    "rgba(93, 255, 188, 1)",
    "rgba(167, 141, 102, 1)",
    "rgba(241, 184, 97, 1)",
    "rgba(0, 255, 25, 1)",
  ];

  const firstRowLabels = allLabels.slice(0, 5);
  const secondRowLabels = allLabels.slice(5);
  const firstRowColors = allColors.slice(0, 5);
  const secondRowColors = allColors.slice(5);

  const vdata = isAllZero
    ? {
        datasets: [
          {
            data: [1], // dummy values to show full circle
            backgroundColor: ["#e0e0e0"], // actual color + dummy
            hoverBackgroundColor: ["#e0e0e0"],
            borderWidth: 0,
          },
        ],
        labels: [],
      }
    : {
        datasets: [
          {
            data: actualData,
            backgroundColor: allColors,
            hoverBackgroundColor: allColors,
          },
        ],
        labels: allLabels,
      };

  const totalCount = isAllZero
    ? 0
    : actualData.reduce((sum, val) => sum + val, 0);
  if (totalCount > 0) {
  } else {
  }

  const getsingleConsignmentData = async (id) => {
    setLoading(true);
    const { data } = await CALL_API("GET", `consignment/getById/${id}`);
    setSingleConsignment(data);
    getHistoryDetails(id);
    setLoading(false);
  };

  const getsingleCconsignorData = async (id) => {
    setLoading(true);
    const { data } = await CALL_API("GET", `consignment/getById/${id}`);
    setSingleConsignor(data);
    getHistoryDetails(id);
    setLoading(false);
  };

  const getsingleHistoryData = async (id) => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `consignment/getDriverLocation?ConsignId=${id}&EvType=1`,
    );
    setSingleHistory(data?.locations);
    setLoading(false);
  };

  const getSingletripData = async (id) => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `home/getVehicleDashboard?vehId=${id}&date=${moment(new Date()).format(
        "YYYY/MM/DD",
      )}`,
      // `home/getTimeline?vehId=&date=${moment(new Date()).format(
      //   "YYYY/MM/DD"
      // )}`
    );
    setSingleTrip(data);
    setLoading(false);
  };

  const data = isEmpty
    ? {
        datasets: [
          {
            data: [1], // dummy data
            backgroundColor: ["#e0e0e0"], // light gray background
            hoverBackgroundColor: ["#e0e0e0"],
          },
        ],
        labels: [],
      }
    : {
        datasets: [
          {
            data: [kpiCount?.Resolved, kpiCount?.Unresolved], // Example data
            backgroundColor: ["#00BC13", "#F20000"],
            hoverBackgroundColor: ["#00BC13", "#F20000"],
          },
        ],
        labels: ["Resolved", "Unresolved"],
      };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const value = cdataa.datasets[0].data[tooltipItem.dataIndex];
            const label = cdataa.labels[tooltipItem.dataIndex];
            return `${label}: ${value}`;
          },
        },
      },
      datalabels: {
        display: false, // ✅ Disable datalabels inside the chart
      },
    },
    cutout: "70%",
  };
  const options1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const value = data.datasets[0].data[tooltipItem.dataIndex];
            const label = data.labels[tooltipItem.dataIndex];
            return `${label}: ${value}`;
          },
        },
      },
      datalabels: {
        display: false, // ✅ Disable datalabels inside the chart
      },
    },
    cutout: "70%",
  };

  const assigned = consignmentCount?.Assigned || 0;
  const unassigned = consignmentCount?.Unassigned || 0;
  const totall = assigned + unassigned;
  const isEmptyy = totall === 0;
  const cdataa = {
    datasets: [
      {
        data: isEmptyy ? [1] : [assigned, unassigned],
        backgroundColor: isEmptyy
          ? ["#D3D3D3"] // Gray donut
          : ["#0176EC", "#E4A400"], // Your actual colors
        hoverBackgroundColor: isEmptyy ? ["#D3D3D3"] : ["#0176EC", "#E4A400"],
        borderWidth: 0, // Optional for cleaner donut
      },
    ],
    labels: isEmptyy ? [] : ["Assigned", "Unassigned"],
  };

  const options3 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const value = vdata.datasets[0].data[tooltipItem.dataIndex];
            const label = vdata.labels[tooltipItem.dataIndex];
            return `${label}: ${value}`;
          },
        },
      },
      datalabels: {
        display: false, // ✅ Disable datalabels inside the chart
      },
    },
    cutout: "70%",
  };

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(value).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };

  const getTotalKpiCount = async () => {
    try {
      const { data } = await CALL_API(
        "POST",
        "kpiAlert/getKPIResolvedUnresolvedCount",
        {
          mcId: userInfo?.MCID,
          startDate:
            dayjs(formValues?.date).format("YYYY-MM-DD") ||
            moment(new Date()).format("YYYY-MM-DD"),
          endDate:
            moment(formValues?.date).format("YYYY-MM-DD") ||
            moment(new Date()).format("YYYY-MM-DD"),
          recName: "",
          custName: "",
          transporter: "",
          driverName: "",
          regNo: "",
        },
      );
      setKpiCount(data[0]);
    } catch (error) {
      console.error("[getTotalKpiCount] error -->", error);
    }
  };

  const getTotalVehicleEventCount = async () => {
    try {
      const { data } = await CALL_API(
        "POST",
        "events/getVehicleEventsCount",

        {
          mcId: userInfo?.MCID,
          pickupDate:
            dayjs(formValues?.date).format("YYYY-MM-DD") ||
            moment(new Date()).format("YYYY-MM-DD"),
          vehId: formValues?.vehicle,
          cust: formValues?.consignor,
          shipper: formValues?.transporter,
          receiver: 0,
          driver: 0,
          tripType: formValues?.tripType,
        },
      );
      setVehicleEventCount(data);
      // setVehicleEventCount(data?.map((item, index)=> item )?.find((value) =>  value?.EventStatus  === EventType?.value  ).ConsignmentCount || 0);
    } catch (error) {
      console.error("[getTotalKpiCount] error -->", error);
    }
  };

  const getTotalConsignmentCount = async () => {
    try {
      const selectedDate = formValues?.date || new Date();
      const startDate = dayjs(selectedDate)
        .startOf("month")
        .format("YYYY-MM-DD"); // Start of selected month
      const endDate = dayjs().format("YYYY-MM-DD"); // Today's date

      const payload = {
        mcId: userInfo?.MCID,
        startDate: startDate,
        endDate: endDate,
        tripType: formValues?.tripType || 0,
        cust: formValues?.consignor || 0,
        shipper: formValues?.transporter || 0,
        vehId: formValues?.vehicle,
        // regNo: vehicleList?.fing((item)=>item?.vehId === formValues?.vehicle)?.REGNO || "",
      };
      const { data } = await CALL_API(
        "POST",
        "/consignment/getCountAssUnassConsignment",
        {
          mcId: userInfo?.MCID,
          startDate: dayjs(formValues?.date).format("YYYY-MM-DD"),
          endDate: dayjs(formValues?.date).format("YYYY-MM-DD"),
          vehid: formValues?.vehicle || 0,
          cust: formValues?.consignor || 0,
          shipper: formValues?.transporter || 0,

          tripType: formValues?.tripType || 0,
        },
      );

      setConsignmentCount(data[0]);
    } catch (error) {
      console.error("[getTotalConsignmentCount] error -->", error);
    }
  };

  const getVehicleDetails = async () => {
    try {
      const { data } = await CALL_API("POST", `panal/getVehiclePanel`, {
        mcId: userInfo?.MCID,
        date:
          moment(form.getFieldValue("date")).format("YYYY-MM-DD") ||
          moment().format("YYYY-MM-DD"),
        forUser: 2,
      });

      setVehicleDetails(data);
    } catch (error) {
      console.error("[getTotalKpiCount] error -->", error);
    }
  };

  const filterVehicleDetails = !vehicleSearch?.trim()
    ? vehicleDetails
    : vehicleDetails.filter((item) =>
        item.DRIVERNAME.toLowerCase().includes(vehicleSearch.toLowerCase()),
      );

  const freeVehicleDetails = filterVehicleDetails?.filter(
    (item) => item?.VCHSTATUS === 1,
  );
  const busyVehicleDetails = filterVehicleDetails?.filter(
    (item) => item?.VCHSTATUS === 2,
  );
  const inActiveVehicleDetails = filterVehicleDetails?.filter(
    (item) => item?.VCHSTATUS === 3,
  );
  //https://7gyutppcwl.execute-api.us-east-1.amazonaws.com/Prod/getSingleConsignById
  const getSingleTripPanel = async () => {
    const { data } = await CALL_API("POST", "getSingleConsignById", {
      consignId: 229413,
      MCID: userInfo?.MCID,
    });
    setsingleTripPanel(data);
  };

  const getHistoryDetails = async (id) => {
    const { data } = await CALL_API("POST", "getConsignEventById", {
      consignId: id,
    });
    setHistoryData(data);
  };

  const formatDateTime = (modon) => {
    const date = new Date(modon);
    return `${date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })}; ${date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  };
  const fetchDashboardTripData = async (values) => {
    const { data } = await CALL_API("POST", "dashboard", {
      MCID: userInfo.MCID,
      RegNo: formValues?.vehicle || null,
      Shipper: formValues?.transporter || null,
      CustId: formValues?.consignor || null,
      TripType: formValues?.tripType || null,
      Date:
        dayjs(formValues?.date).format("YYYY-MM-DD") ||
        moment(new Date()).format("YYYY-MM-DD"),
      Status: null,
    });
    setTripDetails(data);
    setLocationDetialsProps(data);
  };

  const fetchDashboardVehiclesData = async () => {
    const { code } = await CALL_API("GET", "vehicle?MCID=3", {
      MCID: userInfo?.MCID,
    });
  };

  const fetchUnAssignedTripData = async () => {
    const { data } = await CALL_API(
      "GET",
      `homepanal/getUnassTab?date=${
        dayjs(formValues?.date).format("YYYY-MM-DD") ||
        dayjs(new Date()).format("YYYY-MM-DD")
      }&consignor=${formValues?.consignor}&transporter=${
        formValues?.transporter
      }`,
    );
    setUnAssignedTrips(data);
  };

  const filterTripDetails = Array.isArray(tripDetails)
    ? !searchTerm?.trim()
      ? tripDetails
      : tripDetails.filter((item) =>
          item.DriverName?.toLowerCase().includes(searchTerm.toLowerCase()),
        )
    : [];

  // const filterUnAssignTripDetails = !searchTerm?.trim()
  //   ? usAssignedTrips
  //   : usAssignedTrips.filter((item) =>
  //       item.CustName.toLowerCase().includes(searchTerm.toLowerCase())
  //     );

  const filterUnAssignTripDetails = filterTripDetails.filter(
    (item) => item?.TRIPID === null,
  );

  const inporgressTripDetails = filterTripDetails.filter(
    (item) => item?.STATUS === 3,
  );
  const completedTripDetails = filterTripDetails.filter(
    (item) => item?.STATUS === 4,
  );

  useEffect(() => {
    if (selectedReport === "TrackrightAIPlus") {
      fetchDashboardTripData();
      fetchDashboardVehiclesData();
      getVehicleDetails();
      getTotalKpiCount();
      getTotalVehicleEventCount();
      getTotalConsignmentCount();
      getSingleTripPanel();
      fetchUnAssignedTripData();
    }
  }, [formValues, selectedReport]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setMessage(""); // Clear the input field
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleClickme = (id, item) => {
    getsingleConsignmentData(id);
    getsingleHistoryData(id);
    getsingleCconsignorData(id);
    setTripPopupOpen(true);
    setLocationDetialsProps([item]);
    setRouteDetails([item]);
  };

  const tabItems = [
    {
      key: 0,
      label: `Un Assigned (${filterUnAssignTripDetails?.length})`,
      content: (
        <Newbox>
          {filterUnAssignTripDetails?.map((item) => (
            <Row gutter={16} key={item.id}>
              <Col xl={24}>
                <div className="container_one">
                  <div className="container_two">
                    <Ellipse style={{ marginBottom: "0px" }} />
                    <p>
                      {item?.CustName} ({item?.ConsignId})
                    </p>
                  </div>
                  <div className="container_two">
                    <Containerthree style={{ marginBottom: "0px" }} />
                  </div>
                </div>
              </Col>

              <Col xl={24}>
                <div className="container_four">
                  <div className="container_five">
                    <RoundedIcon />
                    <p>Pickup</p>
                    <p>
                      {moment(item?.PickUpDateTime).format(
                        "DD MMM YYYY; HH:mm",
                      )}
                    </p>
                  </div>
                  <p>{item?.StartLocation}</p>
                </div>
                <div className="container_four">
                  <div className="container_five">
                    <RoundedIconthree />
                    <p>Deliver</p>
                    <p>
                      {moment(item?.DropOffDateTime).format(
                        "DD MMM YYYY; HH:mm",
                      )}
                    </p>
                  </div>
                  <div className="container_seven">
                    <p>{item.EndLocation}</p>
                    <Down
                      onClick={() => handleClickme(item?.ConsignId, item)}
                      style={{ fontSize: 24, cursor: "pointer" }}
                    />
                  </div>
                </div>
                <hr />
              </Col>
            </Row>
          ))}
        </Newbox>
      ),
    },
    {
      key: 3,
      label: `Assigned (${inporgressTripDetails?.length})`,
      content: (
        <Newbox>
          {inporgressTripDetails?.map((item) => (
            <Row gutter={16} key={item.id}>
              <Col xl={24}>
                <div className="container_one">
                  <div className="container_two">
                    <Ellipse style={{ marginBottom: "0px" }} />
                    <p>
                      {item?.DriverName} ({item?.RegNo})
                    </p>
                  </div>
                  <div className="container_two">
                    <Containerthree style={{ marginBottom: "0px" }} />
                    <div>
                      {item?.CompletedCount}/{item?.ConsignmentCount}
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={24}>
                <div className="container_four">
                  <div className="container_five">
                    <RoundedIcon />
                    <p>Pickup</p>
                    <p>
                      {moment(item?.PickUpDateTime).format(
                        "DD MMM YYYY; HH:mm",
                      )}
                    </p>
                  </div>
                  <p>{item?.StartLocation}</p>
                </div>
                <div className="container_four">
                  <div className="container_five">
                    <RoundedIconthree />
                    <p>Deliver</p>
                    <p>
                      {moment(item?.DropOffDateTime).format(
                        "DD MMM YYYY; HH:mm",
                      )}
                    </p>
                  </div>
                  <div className="container_seven">
                    <p>{item.EndLocation}</p>
                    <Down
                      onClick={() => handleClickme(item?.CONSIGNID, item)}
                      style={{ fontSize: 24, cursor: "pointer" }}
                    />
                  </div>
                </div>
                <hr />
              </Col>
            </Row>
          ))}
        </Newbox>
      ),
    },
    {
      key: 4,
      label: `Completed (${completedTripDetails?.length})`,
      content: (
        <Newbox>
          {completedTripDetails?.map((item) => (
            <Row gutter={16} key={item.id}>
              <Col xl={24}>
                <div className="container_one">
                  <div className="container_two">
                    <Ellipse style={{ marginBottom: "0px" }} />
                    <p>
                      {item?.DriverName} ({item?.RegNo})
                    </p>
                  </div>
                  <div className="container_two">
                    <Containerthree style={{ marginBottom: "0px" }} />
                    <div>
                      {item?.CompletedCount}/{item?.ConsignmentCount}
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={24}>
                <div className="container_four">
                  <div className="container_five">
                    <RoundedIcon />
                    <p>Pickup</p>
                    <p>
                      {moment(item?.PickUpDateTime).format(
                        "DD MMM YYYY; HH:mm",
                      )}
                    </p>
                  </div>
                  <p>{item?.StartLocation}</p>
                </div>
                <div className="container_four">
                  <div className="container_five">
                    <RoundedIconthree />
                    <p>Deliver</p>
                    <p>
                      {moment(item?.DropOffDateTime).format(
                        "DD MMM YYYY; HH:mm",
                      )}
                    </p>
                  </div>
                  <div className="container_seven">
                    <p>{item.EndLocation}</p>
                    <Down
                      onClick={() => handleClickme(item?.CONSIGNID, item)}
                      style={{ fontSize: 24, cursor: "pointer" }}
                    />
                  </div>
                </div>
                <hr />
              </Col>
            </Row>
          ))}
        </Newbox>
      ),
    },
  ];
  const tabItemsOne = [
    {
      key: "1",
      label: "Details",
      content: (
        <>
          <Row gutter={16}>
            <Col xl={24}>
              <div className="container_forten">
                <div className="container_fordetailstab">
                  <p className="Details">Consign Code</p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.CODE || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Trip Code </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.TRIPCODE || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Pickup Date & Time </p>
                  <p className="Consign_Code_forsubtab">
                    {moment(singleConsignor?.PICKUPDATETIME || "-").format(
                      "DD MMM YYYY; HH:mm",
                    )}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Dropoff Date & Time</p>
                  <p className="Consign_Code_forsubtab">
                    {moment(singleConsignor?.DROPOFFDATETIME || "-").format(
                      "DD MMM YYYY; HH:mm",
                    )}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Pickup Note </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.PICKUPNOTE || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Remark </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.REMARKS || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Pickup Location </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.STARTLOCATION || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Dropoff Location </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.ENDLOCATION || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Consignor </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.CUSTNAME || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Transporter </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.SUPNAME || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Status </p>
                  <p className="Consign_Code_forsubtab">
                    {EventType.find(
                      (e) => e.value === singleConsignor?.LASTMODIFY,
                    )?.name || "-"}{" "}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Details"> Tracking Link </p>
                  <p
                    className="Consign_Code_forsubtab"
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() => handleTrackClick(singleConsignor?.TRIPID)}
                  >
                    Click here to track
                  </p>{" "}
                </div>
              </div>
            </Col>
          </Row>
        </>
      ),
    },
    {
      key: "2",
      label: "Consignor",
      content: (
        <>
          <Row gutter={16}>
            <Col xl={24}>
              <div className="container_forten">
                <div className="container_fordetailstab">
                  <p className="Consign_Code">Consignor</p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.CUSTNAME}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Consign_Code"> Address </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.CUSTADDR || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Consign_Code"> Country </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.country || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Consign_Code"> Dropoff Date & Time</p>
                  <p className="Consign_Code_forsubtab">
                    {moment(singleConsignor?.DROPOFFDATETIME || "-").format(
                      "DD MMM YYYY; HH:mm",
                    )}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Consign_Code"> Contact Person </p>
                  <p className="Consign_Code_forsubtab">-</p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Consign_Code"> Phone </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.CUSTPHONE || "-"}
                  </p>
                </div>
                <div className="container_fordetailstab">
                  <p className="Consign_Code"> Email </p>
                  <p className="Consign_Code_forsubtab">
                    {singleConsignor?.EMAIL || "-"}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </>
      ),
    },
    {
      key: "3",
      label: "History",
      content: (
        <>
          <Row gutter={16}>
            <Col xl={24}>
              <div className="container_fifteen">
                <div className="container_forhistorystab">
                  <p className="Driver_forhistorytab">Driver </p>
                  <p className="Drivername_forhistorytab">
                    {singleConsignor?.DRIVERNAME || "-"}
                  </p>
                </div>
                <div className="container_forhistorystab">
                  <p className="Driver_forhistorytab">Total Trip Time </p>
                  <p className="Drivername_forhistorytab">
                    {singleConsignor?.PICKUPDATETIME &&
                    singleConsignor?.DROPOFFDATETIME
                      ? (() => {
                          const start = moment(singleConsignor?.PICKUPDATETIME);
                          const end = moment(singleConsignor?.DROPOFFDATETIME);
                          const duration = moment.duration(end.diff(start));
                          const days = Math.floor(duration.asDays());
                          const hours = duration.hours();
                          const minutes = duration.minutes();
                          return `${
                            days > 0 ? days + "d " : ""
                          }${hours}h ${minutes}m`;
                        })()
                      : "-"}
                  </p>
                </div>
                <div className="container_forhistorystab">
                  <p className="Driver_forhistorytab">Reg. No </p>
                  <p className="Drivername_forhistorytab">
                    {singleConsignor?.REGNO || "-"}{" "}
                  </p>
                </div>

                <div className="container_forhistorystab">
                  <p className="Driver_forhistorytab">Traveled </p>
                  <p className="Drivername_forhistorytab">
                    {singleConsignor?.ODOEND != null &&
                    singleConsignor?.ODOSTART != null
                      ? `${
                          singleConsignor.ODOEND - singleConsignor.ODOSTART
                        } Km`
                      : "-"}
                  </p>
                </div>
              </div>
              <br />
            </Col>
            <Col xl={24}>
              <div style={{ position: "relative" }}>
                {EventType.map((event, index) => {
                  const matchingHistory = historyData?.find(
                    (h) => h.EVTYPE === event.value,
                  );
                  const isCompleted = !!matchingHistory?.MODON;
                  const modonFormatted = isCompleted
                    ? formatDateTime(matchingHistory.MODON)
                    : "";

                  return (
                    <div
                      key={index}
                      className="container_detailsfornineteen"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        position: "relative",
                        zIndex: 1,
                        opacity: isCompleted ? 1 : 0.4, // dim if not completed
                      }}
                    >
                      {/* Left: Date + Time */}
                      <div style={{ width: "50%", textAlign: "right" }}>
                        <p className="Consign_Code">
                          {isCompleted && (
                            <>
                              {modonFormatted.split(";")[0]};
                              <br />
                              <span>{modonFormatted.split(";")[1]}</span>
                            </>
                          )}
                        </p>
                      </div>

                      {/* Center: Icon and Vertical Line */}
                      <div
                        style={{
                          width: "40px",
                          position: "relative",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {index !== EventType.length - 1 && (
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              height: "80px",
                              borderLeft: "1px dashed #D0D5DD",
                              zIndex: 0,
                            }}
                          />
                        )}

                        {/* Icon */}
                        <div style={{ zIndex: 1 }}>
                          {index % 2 === 0 ? (
                            <RoundedIcon />
                          ) : (
                            <RoundedIconthree />
                          )}
                        </div>
                      </div>

                      {/* Right: Event Name */}
                      <div style={{ width: "30%", textAlign: "left" }}>
                        <p className="Consign_Code_forsubtab">{event.name}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  const handleclose = () => {
    setTripPopupOpen(false);
  };

  const onclickforvechicle = (id) => {
    getSingletripData(id);
    setVehicles(true);
  };

  const tabItemstwo = [
    {
      key: "Free",
      label: `Free ${freeVehicleDetails?.length}`,
      content: (
        <>
          {freeVehicleDetails?.map(function (item, index) {
            return (
              <>
                <div className="w-100 d-flex gap-4">
                  <div className="freecontainer_vehicle   container_forvehicle">
                    {item.image}
                  </div>
                  <div className="w-100 mx-2">
                    <p className="mt-2 pb-0 mb-1">
                      <b>{item.REGNO}</b>
                    </p>
                    <p className="mt-2 pb-0 mb-2">{item.DRIVERNAME}</p>
                    <div className="w-100 d-flex gap-2 justify-content-between">
                      <div className="d-flex gap-2">
                        <p>
                          <PhoneIcon /> {item.DRIVERPHONE}
                        </p>
                      </div>
                      <div className="d-flex gap-3">
                        <p className="mx-2">
                          <ChatIconrounded />
                        </p>
                        <p onClick={() => onclickforvechicle(item?.VEHID)}>
                          <Down />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="mt-0 pt-0"></hr>
              </>
            );
          })}
        </>
      ),
    },
    {
      key: "Busy",
      label: `Busy ${busyVehicleDetails?.length}`,
      content: (
        <>
          {busyVehicleDetails?.map(function (item) {
            return (
              <>
                <div className="w-100 d-flex gap-4">
                  <div className="freecontainer_vehicle   container_forvehicle">
                    {item.image}
                  </div>
                  <div className="w-100 mx-2">
                    <p className="mt-2 pb-0 mb-1">
                      <b>{item.REGNO}</b>
                    </p>
                    <p className="mt-2 pb-0 mb-2">{item.DRIVERNAME}</p>
                    <div className="w-100 d-flex gap-2 justify-content-between">
                      <div className="d-flex gap-2">
                        <p>
                          <PhoneIcon /> {item.DRIVERPHONE}
                        </p>
                      </div>
                      <div className="d-flex gap-3">
                        <p className="mx-2">
                          <ChatIconrounded />
                        </p>
                        <p onClick={() => onclickforvechicle(item?.VEHID)}>
                          <Down />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="mt-0 pt-0"></hr>
              </>
            );
          })}
        </>
      ),
    },
    {
      key: "Inactive",
      label: `Inactive ${inActiveVehicleDetails?.length}`,
      content: (
        <>
          {inActiveVehicleDetails?.map(function (item, index) {
            return (
              <>
                <div className="w-100 d-flex gap-4">
                  <div className="freecontainer_vehicle   container_forvehicle">
                    {item.image}
                  </div>
                  <div className="w-100 mx-2">
                    <p className="mt-2 pb-0 mb-1">
                      <b>{item.REGNO}</b>
                    </p>
                    <p className="mt-2 pb-0 mb-2">{item?.DRIVERNAME}</p>
                    <div className="w-100 d-flex gap-2 justify-content-between">
                      <div className="d-flex gap-2">
                        <p>
                          <PhoneIcon /> {item.DRIVERPHONE}
                        </p>
                      </div>
                      <div className="d-flex gap-3">
                        <p className="mx-2">
                          <ChatIconrounded />
                        </p>
                        <p onClick={() => onclickforvechicle(item?.VEHID)}>
                          <Down />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="mt-0 pt-0"></hr>
              </>
            );
          })}
        </>
      ),
    },
  ];

  const handleclicktruck = () => {
    setContainerTruck(true);
  };

  const tabItemsthree = [
    {
      key: "Details",
      label: "Details",
      content: (
        <>
          <Row gutter={16}>
            <Col xl={24}>
              <div className="container_details">
                <div className="detail_row">
                  <p className="detail_label">Name</p>
                  <p className="detail_value">
                    {singleTrip?.vehicleData?.DriverName}
                  </p>
                </div>
                <div className="detail_row">
                  <p className="detail_label">Email</p>
                  {/* <p className="detail_value">josephujin123@gmail.com</p> */}
                  <p className="detail_value">
                    {singleTrip?.vehicleData?.EMAIL}
                  </p>
                </div>
                <div className="detail_row">
                  <p className="detail_label">Last Location</p>
                  <p className="detail_value">---</p>
                </div>
                <div className="detail_row">
                  <p className="detail_label">Consignment</p>
                  <p className="detail_value">
                    {singleTrip?.tripList?.length > 0
                      ? singleTrip.tripList[0].Code
                      : "---"}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </>
      ),
    },
    {
      key: "Timeline",
      label: "Timeline",
      content: (
        <>
          <Row gutter={16}>
            <Col xl={24}>
              <div className="detail_roww">
                <div className="detail_item">
                  <p className="detail_labell">Total Trip Time</p>
                  <p className="detail_value">0h 0m</p>
                </div>
                <div className="detail_item">
                  <p className="detail_labell">Traveled</p>
                  <p className="detail_value">0 Kms</p>
                </div>
              </div>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  const clickiconvechilefunc = () => {
    setVehicles(false);
  };

  // const modalRef = useRef();
  const drawerRef = useRef(null);

  useEffect(() => {
    if (!containerTruck) return;

    const handleOutsideClick = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setContainerTruck(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [containerTruck]);

  const vehiclecontainerpopupfunc = () => {
    setContainerTruck(false);
  };

  const columns = [
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
    },
    {
      title: "Consignee",
      dataIndex: "RecName",
      key: "RecName",
      render: (RecName) => (
        <>
          <span> {RecName || "---"}</span>
        </>
      ),
    },
    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
      render: (CustName) => (
        <>
          <span> {CustName || "---"}</span>
        </>
      ),
    },
    {
      title: "Transporter",
      dataIndex: "Transporter",
      key: "Transporter",
      render: (Transporter) => (
        <>
          <span> {Transporter || "---"}</span>
        </>
      ),
    },
    {
      title: "Driver",
      dataIndex: "DriverName",
      key: "DriverName",
      render: (DriverName) => (
        <>
          <span> {DriverName || "---"}</span>
        </>
      ),
    },
    {
      title: "  KPI Name",
      dataIndex: "Name",
      key: "KPIname",
    },

    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (Status) => (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {Status === "Resolved" ? (
              <>{Status}</>
            ) : (
              <>
                <Indicator /> {Status}
              </>
            )}
          </div>
        </>
      ),
    },
    {
      title: "Targetduration",
      dataIndex: "DURATION",
      key: "Targetduration",
      width: "20%",
      render: (text, record) => (
        <>
          <div
            className={
              Hoveredrow === record.key
                ? "d-flex align-items-center height-[50px]"
                : "opacity-0"
            }
          >
            {record.Status === "Resolved" ? (
              <Chat className="" />
            ) : Hoveredrow === record.key ? (
              <>
                <div className="d-flex align-items-center gap-3">
                  <Chat className="" />
                  <Button onClick={handleresolveopen} className="resolve_btn">
                    Resolve
                  </Button>
                </div>
              </>
            ) : null}
          </div>
        </>
      ),
    },
  ];

  const handlemouseleave = () => {
    setHoveredRow(null);
  };

  const handleresolveopen = () => {
    setResolveModal(true);
  };
  const handlemouseenter = (key) => {
    setHoveredRow(key);
  };
  const [Hoveredrow, setHoveredRow] = useState(null);
  const [isAddModalVisible, setAddModalVisible] = useState(false);
  const [kpiReporttabledata, setKpiReporttabledata] = useState([]);
  const [resolveModal, setResolveModal] = useState(false);

  const [formDate, SetformData] = useState({
    Kpiname: "",
    consignor: "consignor",
    Consignee: "Consignee",
    Transporter: "Transporter",
    Duration: "Duration",
    Consigncode: "",
    Vehicle: "",
    Driver: "",
  });

  const kpitabledata = async () => {
    try {
      const { data } = await CALL_API(
        "POST",
        `kpi/get_Kpialert_Table?MCID=3&startDate=2025-03-01&endDate=2025-05-30&page=1&pageSize=10`,
      );

      setKpiReporttabledata(data?.KPIAlertTable);
    } catch (error) {
      console.error("Error fetching KPI table data:", error);
    }
  };

  useEffect(() => {
    kpitabledata();
  }, [formValues]);

  const showModalone = (e) => {
    setAddModalVisible(true);
  };
  const closeAddModal = (e) => {
    setAddModalVisible(false);
  };

  const handledrawerclose = (e) => {};
  // const CustomTooltip = ({ active, payload, label , }) => {
  //   if (active && payload?.length) {
  //     return (<>
  //       <div style={{
  //         backgroundColor: '#fff',
  //         padding: '3px 15px',
  //         maxWidth: '220px',
  //         fontSize: '10px',
  //         borderRadius: '8px',
  //         border: '1px solid #ccc',
  //         display:"flex"
  //       }}>
  //          <div
  //             style={{
  //               width: 12,
  //               height: 12,
  //               backgroundColor: ""|| "#888",
  //               borderRadius: 2,
  //               marginRight: 6,
  //               flexShrink: 0,
  //             }}
  //           >
  //           <span>
  //             {entry.name}: {entry.value}
  //           </span>
  //         </div>

  //         <p style={{ margin: 0 }}>{label}</p>
  //         {payload.map((entry, index) => (
  //           <p key={index} style={{ margin: 0 }}>
  //             {entry.name}: {entry.value}
  //           </p>
  //         ))}
  //       </div>
  //       </>
  //     );
  //   }
  //   return null;
  // };

  // const CustomTooltip = ({ active, payload }) => {
  //   if (active && payload?.length) {
  //     return (
  //       <div
  //         style={{
  //           backgroundColor: '#fff',
  //           padding: '3px 15px',
  //           maxWidth: '220px',
  //           fontSize: '12px',
  //           borderRadius: '8px',
  //           border: '1px solid #ccc',
  //         }}
  //       >
  //         {payload.map((entry, index) => (
  //           <div
  //             key={index}
  //             style={{
  //               display: 'flex',
  //               alignItems: 'center',
  //               marginBottom: '4px',
  //             }}
  //           >
  //             <div
  //               style={{
  //                 width: 12,
  //                 height: 12,
  //                 backgroundColor: entry.color || '#888',
  //                 borderRadius: 2,
  //                 marginRight: 8,
  //               }}
  //             />
  //             <span>
  //               {entry.name}: <strong>{entry.value}</strong>
  //             </span>
  //           </div>
  //         ))}
  //       </div>
  //     );
  //   }

  //   return null;
  // };
  const CustomTooltip = ({ active, payload, colors }) => {
    if (active && payload?.length) {
      return (
        <div
          style={{
            backgroundColor: "#fff",
            padding: "3px 15px",
            maxWidth: "220px",
            fontSize: "12px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {payload.map((entry, index) => {
            return (
              <div
                key={index}
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: entry?.payload?.fill || "#888",
                    borderRadius: 2,
                    marginRight: 6,
                  }}
                />
                <span>
                  {entry.name}: {entry.value}
                </span>
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  };
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!drawerOpen) return;

    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setDrawerOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [drawerOpen]);

  const isTripAllowed =
    selectedReport === "TrackrightAIPlus"
      ? homeAIPTrip
      : selectedReport === "TrackRightAI"
        ? homeAITrip
        : selectedReport === "ContainerTracking"
          ? homeCargoTrip
          : false;

  const isVehicleAllowed =
    selectedReport === "TrackrightAIPlus"
      ? homeAIPVehicle
      : selectedReport === "TrackRightAI"
        ? homeAIVehicle
        : selectedReport === "ContainerTracking"
          ? homeCargoVehicle
          : false;
  return (
    <>
      <UIModal
        open={isAddModalVisible}
        onClose={closeAddModal}
        size="md"
        width={850}
        onCancel={closeAddModal}
        closeButton={false}
      >
        <Row>
          <Col xl={14} sm={24}>
            <p className="kpi_alterts_table">0 Kpi Alerts</p>
          </Col>
          <Col xl={24} sm={24}>
            <StyledTable
              dataSource={kpiReporttabledata}
              rowClassName={() => "custom-row"}
              pagination={false}
              columns={columns}
              onRow={(record, index) => ({
                onClick: (e) => {
                  e.stopPropagation();
                  navigate("/reports/kpi report");
                },
              })}
            />
          </Col>
        </Row>
      </UIModal>

      <HomeContainer>
        <div
          style={{
            position: "relative",
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
          }}
          className="mapbox_container_two"
        >
          {/* Map as background */}
          {!isMobile && (
            <div ref={mapContainerRef} className="MapboxWrap_one">
              <MapComponent
                ref={mapContainerRef}
                className="MapboxWrap"
                pinlocation={pinlocation}
                consignmentMap={consignmentMap}
                routeDetails={routeDetails}
              />
            </div>
          )}

          {isMobile && (
            <Card
              style={{
                // padding: "16px 24px",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                marginBottom: 16,
              }}
            >
              {/* <Row
              className="Button-Wrap"
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap", // keep everything in one line
                gap: "12px",
                width: "100%",
              }}
            >
           
              <div
                className="BUTTON_trackrightai"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  minWidth: 0, // allow text truncation if needed
                }}
              >

                <Dropdown overlay={menu} trigger={["click"]}>
                  <ButtonWhite
                    style={{
                      minWidth: 160,
                      // minHeight: 50,
                     minHeight: 0,
                      backgroundColor: "#d0f0c0", // light green
                      color: "#000",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {selectedReport === "ContainerTracking" ?
                      window.innerWidth >= 320 && window.innerWidth <= 426 ?
                        <span style={{ fontSize: "11px" }}> TrackRight AI Cargo</span> : null : selectedReport === "TrackrightAIPlus" ? " Trackright AI+" : "TrackRight AI" || "TrackRight AI"} <DownOutlined />
                  </ButtonWhite>
                </Dropdown>

             
              </div>

              <div
                className="button-style"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap:"12px",
                  marginLeft: "auto", // <-- pushes icons to the far right
                  flexShrink: 0,
                }}
              >
                {!drawerOpen ? (
                  <PrimaryActive onClick={() => setDrawerOpen(true)}>
                    <Icon>
                      <ArrowUpRight />
                    </Icon>
                  </PrimaryActive>
                ) : (
                  <DrawercloseIcon
                    style={{ cursor: "pointer", width: 40, height: 40 }}
                    onClick={() => setDrawerOpen(false)}
                  />
                )}

                <TruckIcon onClick={handleclicktruck}>
                  <Icon>
                    <Truck />
                  </Icon>
                </TruckIcon>

                <Badge count={filterCount}>
                  <Filterpopup onClick={() => setIsModalOpen(true)}>
                    <Icon>
                      <Filter />
                    </Icon>
                  </Filterpopup>
                </Badge>
              </div>
            </Row> */}

              <Row>
                <Col span={24}>
                  <div
                    className="Button-Wrap"
                    style={
                      window.innerWidth >= 320 && window.innerWidth <= 374
                        ? {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            // gap: "12px",
                            width: "100%",
                            backgroundColor: "",
                            marginLeft: "5px",
                          }
                        : {
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "nowrap",
                            gap: "17px",
                            width: "100%",
                            marginLeft: "5px",
                          }
                    }
                  >
                    {/* --- Left side: Buttons / Dropdown --- */}
                    <div
                      className="BUTTON_trackrightai"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        minWidth: 0, // allow text truncation if needed
                      }}
                    >
                      <Dropdown overlay={menu} trigger={["click"]}>
                        <ButtonWhite
                          style={{
                            minWidth: 195,
                            marginLeft: "20px",
                            // minHeight: 50,
                            minHeight: 0,
                            backgroundColor: "#d0f0c0", // light green
                            color: "#000",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom:
                              window.innerWidth >= 320 &&
                              window.innerWidth <= 374
                                ? "15px"
                                : "0px",
                            width:
                              window.innerWidth >= 320 &&
                              window.innerWidth <= 374
                                ? "190px"
                                : "auto",
                          }}
                        >
                          {selectedReport === "ContainerTracking" ? (
                            window.innerWidth >= 320 &&
                            window.innerWidth <= 426 ? (
                              <span
                                style={{
                                  wordBreak: "break-word",
                                  whiteSpace: "normal",
                                  textAlign: "center",
                                  fontSize: "13px",
                                }}
                              >
                                {" "}
                                TrackRight AI Cargo
                              </span>
                            ) : null
                          ) : selectedReport === "TrackrightAIPlus" ? (
                            " Trackright AI+"
                          ) : (
                            "TrackRight AI" || "TrackRight AI"
                          )}{" "}
                          <DownOutlined />
                        </ButtonWhite>
                      </Dropdown>
                    </div>
                    {/* --- Right side: Icons --- */}
                    <div
                      className="button-style"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        // marginLeft: "auto", // <-- pushes icons to the far right
                        flexShrink: 0,
                      }}
                    >
                      {!drawerOpen ? (
                        <PrimaryActive
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (!isVehicleAllowed) return;
                            setDrawerOpen(true);
                          }}
                        >
                          <Icon style={{ cursor: "pointer" }}>
                            <ArrowUpRight style={{ cursor: "pointer" }} />
                          </Icon>
                        </PrimaryActive>
                      ) : (
                        <DrawercloseIcon
                          style={{ cursor: "pointer", width: 40, height: 40 }}
                          onClick={() => setDrawerOpen(false)}
                        />
                      )}

                      <TruckIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (!isTripAllowed) return;
                          handleclicktruck();
                        }}
                      >
                        <Icon style={{ cursor: "pointer" }}>
                          <Truck style={{ cursor: "pointer" }} />
                        </Icon>
                      </TruckIcon>

                      <Badge count={filterCount}>
                        <Filterpopup
                          onClick={() => setIsModalOpen(true)}
                          style={{ cursor: "pointer" }}
                        >
                          <Icon style={{ cursor: "pointer" }}>
                            <Filter style={{ cursor: "pointer" }} />
                          </Icon>
                        </Filterpopup>
                      </Badge>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          )}

          {isMobile && (
            <Newbox>
              <Card
                className="new_container_vehicle"
                title={
                  selectedReport === "TrackRightAI"
                    ? "Vehicles"
                    : selectedReport === "ContainerTracking"
                      ? "Events"
                      : selectedReport === "TrackrightAIPlus"
                        ? "Events"
                        : "Vehicles"
                }
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  padding: "16px",
                }}
              >
                <div
                  className="container_two_vehicles"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent:
                      window.innerWidth <= 768 ? "center" : "space-between",
                    flexDirection: "row",
                    width: "100%",
                    gap: "16px",
                  }}
                >
                  {/* Left Legend */}
                  <div
                    style={{
                      flex: window.innerWidth <= 768 ? "1 1 100%" : "0 0 150px",
                      display: "flex",
                      justifyContent:
                        window.innerWidth <= 768 ? "center" : "flex-start",
                      order: window.innerWidth <= 768 ? 2 : 1, // mobile: after PieChart
                    }}
                  >
                    <VehicleLegend
                      labels={charts.vehicle.labels}
                      colors={charts.vehicle.datasets[0].backgroundColor}
                      values={charts.vehicle.datasets[0].data}
                      side="left"
                    />
                  </div>

                  {/* PieChart Center */}
                  <div
                    style={{
                      flex: window.innerWidth <= 768 ? "1 1 100%" : "0 0 190px",
                      height: "150px",
                      display: "flex",
                      justifyContent: "center",
                      order: window.innerWidth <= 768 ? 1 : 2, // mobile: first
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={charts.vehicle.labels.map((label, i) => ({
                            name: label,
                            value: charts.vehicle.datasets[0].data[i],
                          }))}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          innerRadius={55}
                          outerRadius={75}
                          label={false}
                          labelLine={false}
                          stroke="none"
                        >
                          {charts.vehicle.datasets[0].backgroundColor.map(
                            (color, i) => (
                              <Cell key={i} fill={color} stroke="none" />
                            ),
                          )}
                        </Pie>
                        <text
                          x="50%"
                          y="50%"
                          textAnchor="middle"
                          dominantBaseline="central"
                          fontStyle="italic"
                          fontSize="12"
                          fill="#555"
                          dy="-14"
                        >
                          Assigned
                        </text>
                        <text
                          x="50%"
                          y="50%"
                          textAnchor="middle"
                          dominantBaseline="middle"
                          fontSize="12"
                          fontWeight="bold"
                          fill="#333"
                          dy="10"
                          style={{ pointerEvents: "none" }}
                        >
                          {charts.vehicle.datasets[0].data.reduce(
                            (a, b) => a + b,
                            0,
                          )}
                        </text>
                        <Tooltip
                          content={
                            <CustomTooltip
                              colors={
                                charts.vehicle.datasets[0].backgroundColor
                              }
                            />
                          }
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>

                  {/* Right Legend */}
                  <div
                    style={{
                      flex: window.innerWidth <= 768 ? "1 1 100%" : "0 0 150px",
                      display: "flex",
                      justifyContent:
                        window.innerWidth <= 768 ? "center" : "flex-end",
                      order: 3, // always last
                    }}
                  >
                    <VehicleLegend
                      labels={charts.vehicle.labels}
                      colors={charts.vehicle.datasets[0].backgroundColor}
                      values={charts.vehicle.datasets[0].data}
                      side="right"
                    />
                  </div>
                </div>
              </Card>
            </Newbox>
          )}
          {isMobile && (
            <div>
              <Card
                title="KPI Alerts"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  marginBottom: 16,
                  marginTop: 16,
                }}
                bodyStyle={{
                  padding: "16px",
                  display: "flex",
                  justifyContent: "center", // center the container horizontally
                  alignItems: "center", // center vertically
                }}
              >
                {/* Wrapper to center content */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row", // left-right layout
                    alignItems: "center",
                    justifyContent: "center", // center the chart+legend together
                    gap: "24px",
                  }}
                >
                  {/* PieChart on Left */}
                  <div
                    style={{
                      width: 150,
                      height: 150,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={charts.kpi.labels.map((label, i) => ({
                            name: label,
                            value: charts.kpi.datasets[0].data[i],
                          }))}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          innerRadius={33}
                          outerRadius={55}
                          paddingAngle={-20}
                          cornerRadius={48}
                          label={false}
                          labelLine={false}
                          stroke="none"
                        >
                          {charts.kpi.datasets[0].backgroundColor.map(
                            (color, i) => (
                              <Cell key={i} fill={color} stroke="none" />
                            ),
                          )}
                        </Pie>
                        <text
                          x="50%"
                          y="50%"
                          textAnchor="middle"
                          dominantBaseline="central"
                          fontStyle="italic"
                          fontSize="12"
                          fill="#555"
                          dy="-14"
                        >
                          Total
                        </text>
                        <text
                          x="50%"
                          y="50%"
                          textAnchor="middle"
                          dominantBaseline="central"
                          fontSize="12"
                          fontWeight="bold"
                          fill="#333"
                          dy="10"
                          style={{ pointerEvents: "none" }}
                        >
                          {charts.kpi.datasets[0].data.reduce(
                            (a, b) => a + b,
                            0,
                          )}
                        </text>
                        <Tooltip
                          content={
                            <CustomTooltip
                              colors={charts.kpi.datasets[0].backgroundColor}
                            />
                          }
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>

                  {/* Legend on Right */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <KpiLegend
                      labels={charts.kpi.labels}
                      data={charts.kpi.datasets[0].data}
                      colors={charts.kpi.datasets[0].backgroundColor}
                    />
                  </div>
                </div>
              </Card>
            </div>
          )}

          {isMobile && (
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    fontWeight: "bold",
                    fontSize: 16,
                  }}
                >
                  <span>
                    {selectedReport === "TrackRightAI"
                      ? "Consignments"
                      : selectedReport === "ContainerTracking"
                        ? "E-Seals"
                        : selectedReport === "TrackrightAIPlus"
                          ? "Consignments"
                          : "Consignments"}
                  </span>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: 20,
                      lineHeight: 1,
                      color: "#2c963d",
                    }}
                    onClick={() => {
                      if (selectedReport === "TrackRightAI") {
                        navigate("/consignmentAI", {
                          state: { tab: "CreateSingleConsignment" },
                        });
                      } else if (selectedReport === "ContainerTracking") {
                        navigate("/tripMonitoring", {
                          state: { action: "openConsignmentDrawer" },
                        });
                      } else if (selectedReport === "TrackrightAIPlus") {
                        navigate("/Consignment1", {
                          state: { tab: "CreateSingleConsignmentAI+" },
                        });
                      }
                    }}
                  >
                    +
                  </span>
                </div>
              }
              style={{
                height: 270,
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
              bodyStyle={{
                padding: "16px",
                display: "flex",
                flexDirection: "row", // left-right layout
                alignItems: "center",
                justifyContent: "center",
                gap: "24px",
              }}
            >
              {/* PieChart on Left */}
              <div
                style={{
                  width: 120,
                  height: 120,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={charts.consignment.labels.map((label, i) => ({
                        name: label,
                        value: charts.consignment.datasets[0].data[i],
                      }))}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      innerRadius={33}
                      outerRadius={55}
                      paddingAngle={-20}
                      cornerRadius={48}
                      label={false}
                      labelLine={false}
                      stroke="none"
                    >
                      {charts.consignment.datasets[0].backgroundColor.map(
                        (color, i) => (
                          <Cell key={i} fill={color} stroke="none" />
                        ),
                      )}
                    </Pie>
                    <text
                      x="50%"
                      y="50%"
                      textAnchor="middle"
                      dominantBaseline="central"
                      fontStyle="italic"
                      fontSize="12"
                      fill="#555"
                      dy="-14"
                    >
                      Total
                    </text>
                    <text
                      x="50%"
                      y="50%"
                      textAnchor="middle"
                      dominantBaseline="central"
                      fontSize="12"
                      fontWeight="bold"
                      fill="#333"
                      dy="10"
                      style={{ pointerEvents: "none" }}
                    >
                      {isNaN(
                        charts.consignment.datasets[0].data.reduce(
                          (a, b) => Number(a) + Number(b),
                          0,
                        ),
                      )
                        ? 0
                        : charts.consignment.datasets[0].data.reduce(
                            (a, b) => Number(a) + Number(b),
                            0,
                          )}
                    </text>
                    <Tooltip
                      content={
                        <CustomTooltip
                          colors={
                            charts.consignment.datasets[0].backgroundColor
                          }
                        />
                      }
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>

              {/* Legend on Right */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <ConsignmentLegend
                  labels={charts.consignment.labels}
                  data={charts.consignment.datasets[0].data}
                  colors={charts.consignment.datasets[0].backgroundColor}
                />
              </div>
            </Card>
          )}

          {/* Foreground UI */}
          {!isMobile && (
            <div
              style={{
                position: "absolute",
                bottom: 60,
                left: 0,
                // width: "85%",
                width: "100%",
                zIndex: 2,
                padding: 10,
              }}
            >
              <Row className="Button-Wrap">
                <div
                  className="BUTTON_trackrightai"
                  style={{ display: "flex", gap: "0px" }}
                >
                  {subscriptionList.includes("AI_HME") && homeAIRead && (
                    <ButtonWhite
                      style={{ minWidth: 160, minHeight: 50 }}
                      onClick={() => {
                        if (selectedReport === "TrackRightAI")
                          setShowCharts(!showCharts);
                        setSelectedReport("TrackRightAI");
                        if (window.innerWidth <= 320) {
                          setShowCharts(false);
                        }
                      }}
                    >
                      TrackRight AI
                    </ButtonWhite>
                  )}
                  {subscriptionList.includes("CONT_HME") && homeCargoRead && (
                    <ButtonWhite
                      style={{ minWidth: 194, minHeight: 50 }}
                      onClick={() => {
                        if (selectedReport === "ContainerTracking")
                          setShowCharts(!showCharts);
                        setSelectedReport("ContainerTracking");
                      }}
                    >
                      TrackRight AI Cargo
                    </ButtonWhite>
                  )}
                  {subscriptionList.includes("AIPLS_HME") && homeAIPRead && (
                    <ButtonWhite
                      style={{ minWidth: 160, minHeight: 50 }}
                      onClick={() => {
                        if (selectedReport === "TrackrightAIPlus")
                          setShowCharts(!showCharts);
                        setSelectedReport("TrackrightAIPlus");
                      }}
                    >
                      Trackright AI+
                    </ButtonWhite>
                  )}
                </div>
                <div className="button-style">
                  {/* <Button
                  shape="circle"
                  icon={showCharts ? <DownOutlined /> : <UpOutlined />}
                  onClick={(e) => {
                    setShowCharts(!showCharts);
                  }}
                  style={{
                    border: "1px solid #2c963d",
                    color: "#2c963d",
                    background: "#fff",
                    fontSize: 18,
                    width: 40,
                    height: 40,
                    display: "flex",
                  }}
                /> */}
                </div>
              </Row>
              {showCharts && (
                <HomeContainer>
                  {" "}
                  <div className="scrollable_container">
                    {" "}
                    <Row
                      className="my_custom_row"
                      gutter={12}
                      justify="center"
                      style={{ marginTop: 10, width: "100%" }}
                    >
                      {/* KPI/Eseal/Alerts Card */}
                      <Col span={7} xxl={7} xl={7} xs={24} sm={12} md={6}>
                        <Card
                          title={
                            selectedReport === "TrackRightAI"
                              ? "KPI Alerts"
                              : selectedReport === "ContainerTracking"
                                ? "KPI Alerts"
                                : selectedReport === "TrackrightAIPlus"
                                  ? "KPI Alerts"
                                  : "KPI Alerts"
                          }
                          style={{
                            height: 270,
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                          bodyStyle={{
                            paddingTop: 4,
                            paddingBottom: 12,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              width: 120,
                              height: 120,
                            }}
                          >
                            <ResponsiveContainer width="100%" height="100%">
                              <PieChart>
                                <Pie
                                  data={charts.kpi.labels.map((label, i) => ({
                                    name: label,
                                    value: charts.kpi.datasets[0].data[i],
                                  }))}
                                  dataKey="value"
                                  nameKey="name"
                                  cx="50%"
                                  cy="50%"
                                  innerRadius={33}
                                  outerRadius={55}
                                  paddingAngle={-20}
                                  cornerRadius={48}
                                  fill="#8884d8"
                                  label={false}
                                  labelLine={false}
                                  stroke="none"
                                >
                                  {charts.kpi.datasets[0].backgroundColor.map(
                                    (color, i) => (
                                      <Cell
                                        key={i}
                                        fill={color}
                                        stroke="none"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleKpiLabelClick(
                                            charts.kpi.labels[i],
                                            dayjs(
                                              formValues?.date,
                                            ).toISOString() || dayjs(),
                                          )
                                        }
                                      />
                                    ),
                                  )}
                                </Pie>
                                <text
                                  x="50%"
                                  y="50%"
                                  textAnchor="middle"
                                  dominantBaseline="central"
                                  fontStyle="italic"
                                  fontSize="12"
                                  fill="#555"
                                  dy="-14" // move Total slightly up
                                >
                                  Total
                                </text>

                                <text
                                  x="50%"
                                  y="50%"
                                  textAnchor="middle"
                                  dominantBaseline="central"
                                  fontSize="12"
                                  fontWeight="bold"
                                  fill="#333"
                                  dy="10" // move value slightly down
                                  style={{ pointerEvents: "none" }}
                                >
                                  {isNaN(
                                    charts.kpi.datasets[0].data.reduce(
                                      (a, b) => a + b,
                                      0,
                                    ),
                                  )
                                    ? 0
                                    : charts.kpi.datasets[0].data.reduce(
                                        (a, b) => a + b,
                                        0,
                                      )}
                                </text>

                                <Tooltip
                                  content={
                                    <CustomTooltip
                                      colors={
                                        charts.vehicle.datasets[0]
                                          .backgroundColor
                                      }
                                    />
                                  }
                                />
                              </PieChart>
                            </ResponsiveContainer>
                          </div>
                          <KpiLegend
                            labels={charts.kpi.labels}
                            data={charts.kpi.datasets[0].data}
                            colors={charts.kpi.datasets[0].backgroundColor}
                          />
                        </Card>
                      </Col>

                      {/* Consignment/Eseal/Containers Card */}
                      <Col span={7} xxl={7} xl={7} xs={24} sm={12} md={6}>
                        <Card
                          title={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                                fontWeight: "bold",
                                fontSize: 16,
                              }}
                            >
                              <span>
                                {selectedReport === "TrackRightAI"
                                  ? "Consignments"
                                  : selectedReport === "ContainerTracking"
                                    ? "E-Seals"
                                    : selectedReport === "TrackrightAIPlus"
                                      ? "Consignments"
                                      : "Consignments"}
                              </span>
                              <span
                                style={{
                                  cursor: "pointer",
                                  fontSize: 20,
                                  lineHeight: 1,
                                  color: "#2c963d",
                                }}
                                onClick={() => {
                                  if (selectedReport === "TrackRightAI") {
                                    navigate("/consignmentAI", {
                                      state: { tab: "CreateSingleConsignment" },
                                    });
                                  } else if (
                                    selectedReport === "ContainerTracking"
                                  ) {
                                    navigate("/tripMonitoring", {
                                      state: {
                                        action: "openConsignmentDrawer",
                                      },
                                    });
                                  } else if (
                                    selectedReport === "TrackrightAIPlus"
                                  ) {
                                    navigate("/Consignment1", {
                                      state: {
                                        tab: "CreateSingleConsignmentAI+",
                                      },
                                    });
                                  }
                                }}
                              >
                                +
                              </span>
                            </div>
                          }
                          style={{
                            height: 270,
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                          bodyStyle={{
                            paddingTop: 8,
                            paddingBottom: 12,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ width: 120, height: 120 }}>
                            <ResponsiveContainer width="100%" height="100%">
                              <PieChart>
                                <Pie
                                  data={charts.consignment.labels.map(
                                    (label, i) => ({
                                      name: label,
                                      value:
                                        charts.consignment.datasets[0].data[i],
                                    }),
                                  )}
                                  dataKey="value"
                                  nameKey="name"
                                  cx="50%"
                                  cy="50%"
                                  innerRadius={33}
                                  outerRadius={55}
                                  paddingAngle={-20}
                                  cornerRadius={48}
                                  fill="#8884d8"
                                  label={false}
                                  labelLine={false}
                                  stroke="none"
                                >
                                  {charts.consignment.datasets[0].backgroundColor.map(
                                    (color, i) => (
                                      <Cell
                                        key={i}
                                        fill={color}
                                        stroke="none"
                                        onClick={() => handleCellClick(i)}
                                        style={{ cursor: "pointer" }}
                                      />
                                    ),
                                  )}
                                </Pie>
                                <text
                                  x="50%"
                                  y="50%"
                                  textAnchor="middle"
                                  dominantBaseline="central"
                                  fontStyle="italic"
                                  fontSize="12"
                                  fill="#555"
                                  dy="-14" // move Total slightly up
                                >
                                  Total
                                </text>
                                <text
                                  x="50%"
                                  y="50%"
                                  textAnchor="middle"
                                  dominantBaseline="middle"
                                  fontSize="12"
                                  fontWeight="bold"
                                  fill="#333"
                                  dy="10"
                                  style={{ pointerEvents: "none" }}
                                >
                                  {isNaN(
                                    charts.consignment.datasets[0].data.reduce(
                                      (a, b) => Number(a) + Number(b),
                                      0,
                                    ),
                                  )
                                    ? 0
                                    : charts.consignment.datasets[0].data.reduce(
                                        (a, b) => Number(a) + Number(b),
                                        0,
                                      )}
                                </text>
                                <Tooltip
                                  content={
                                    <CustomTooltip
                                      colors={
                                        charts.consignment.datasets[0]
                                          .backgroundColor
                                      }
                                    />
                                  }
                                />{" "}
                              </PieChart>
                            </ResponsiveContainer>
                          </div>

                          <ConsignmentLegend
                            labels={charts.consignment.labels}
                            data={charts.consignment.datasets[0].data}
                            colors={
                              charts.consignment.datasets[0].backgroundColor
                            }
                          />
                        </Card>
                      </Col>

                      {/* Vehicles/Events/Containers Card */}
                      <Newbox>
                        <Col
                          span={10}
                          xxl={10}
                          xl={10}
                          xs={24}
                          sm={12}
                          md={12}
                          className="new_container_three_vehicle"
                        >
                          <Card
                            className="new_container_vehicle"
                            title={
                              selectedReport === "TrackRightAI"
                                ? "Vehicles"
                                : selectedReport === "ContainerTracking"
                                  ? "Events"
                                  : selectedReport === "TrackrightAIPlus"
                                    ? "Events"
                                    : "Vehicles"
                            }
                            style={{
                              height: 270,
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <div
                              className="container_two_vehicles"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                padding: "20px 10px",
                              }}
                            >
                              {/* Left Legend */}
                              <VehicleLegend
                                labels={charts.vehicle.labels}
                                colors={
                                  charts.vehicle.datasets[0].backgroundColor
                                }
                                values={charts.vehicle.datasets[0].data}
                                side="left"
                              />

                              {/* PieChart Center */}
                              <div style={{ width: 190, height: 150 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                  <PieChart>
                                    <Pie
                                      data={charts.vehicle.labels.map(
                                        (label, i) => ({
                                          name: label,
                                          value:
                                            charts.vehicle.datasets[0].data[i],
                                        }),
                                      )}
                                      dataKey="value"
                                      nameKey="name"
                                      cx="50%"
                                      cy="50%"
                                      innerRadius={55}
                                      outerRadius={75}
                                      label={false}
                                      labelLine={false}
                                      stroke="none"
                                    >
                                      {charts.vehicle.datasets[0].backgroundColor.map(
                                        (color, i) => (
                                          <Cell
                                            key={i}
                                            fill={color}
                                            stroke="none"
                                            onClick={() =>
                                              handleCellClickVehicle(i)
                                            }
                                            style={{ cursor: "pointer" }}
                                          />
                                        ),
                                      )}
                                    </Pie>
                                    <text
                                      x="50%"
                                      y="50%"
                                      textAnchor="middle"
                                      dominantBaseline="central"
                                      fontStyle="italic"
                                      fontSize="12"
                                      fill="#555"
                                      dy="-14" // move Total slightly up
                                    >
                                      Assigned
                                    </text>
                                    <text
                                      x="50%"
                                      y="50%"
                                      textAnchor="middle"
                                      dominantBaseline="middle"
                                      fontSize="12"
                                      fontWeight="bold"
                                      fill="#333"
                                      dy="10"
                                      style={{ pointerEvents: "none" }}
                                    >
                                      {charts.vehicle.datasets[0].data.reduce(
                                        (a, b) => a + b,
                                        0,
                                      )}
                                    </text>
                                    <Tooltip
                                      content={
                                        <CustomTooltip
                                          colors={
                                            charts.vehicle.datasets[0]
                                              .backgroundColor
                                          }
                                        />
                                      }
                                    />
                                  </PieChart>
                                </ResponsiveContainer>
                              </div>

                              {/* Right Legend */}
                              <VehicleLegend
                                labels={charts.vehicle.labels}
                                colors={
                                  charts.vehicle.datasets[0].backgroundColor
                                }
                                values={charts.vehicle.datasets[0].data}
                                side="right"
                              />
                            </div>
                          </Card>
                        </Col>
                      </Newbox>
                    </Row>
                  </div>{" "}
                </HomeContainer>
              )}
            </div>
          )}
        </div>
      </HomeContainer>
      {/* Floating Buttons */}

      {!isMobile && (
        <Newbox>
          <div
            className="float_button_continer_for_ArrowUpRight"
            style={{ position: "fixed", top: "170px", left: "", zIndex: 9999 }}
          >
            {!drawerOpen ? (
              <PrimaryActive
                className="my-2 container_close"
                onClick={() => setDrawerOpen(true)}
              >
                <Icon>
                  <ArrowUpRight />
                </Icon>
              </PrimaryActive>
            ) : (
              <DrawercloseIcon
                className="my-2"
                style={{ cursor: "pointer", width: 40, height: 40 }}
                onClick={() => setDrawerOpen(false)}
              />
            )}
          </div>
        </Newbox>
      )}

      {!isMobile && (
        <Newbox>
          <FloatButtonContainer className="float_button_container">
            <TruckIcon className="my-2" onClick={handleclicktruck}>
              <Icon>
                <Truck />
              </Icon>
            </TruckIcon>
            <Badge count={filterCount}>
              <Filterpopup onClick={() => setIsModalOpen(true)}>
                <Icon>
                  <Filter />
                </Icon>
              </Filterpopup>
            </Badge>
          </FloatButtonContainer>
        </Newbox>
      )}

      {drawerOpen && (
        <HomeContainer>
          <Newbox>
            {
              <Drawer
                ref={drawerRef}
                className="container_for_trip"
                style={{
                  marginTop: "130px",
                  width: "380px",
                  // marginRight: "100px",
                  marginRight: "850px",
                  top: "47px",
                  // left:  "260px",
                  left:
                    window.innerWidth >= 320 && window.innerWidth <= 374
                      ? "200px"
                      : "260px",
                  borderRadius: "20px",
                  height: "650px",
                  overflowY: "scroll",
                  padding: "20px",
                  zIndex: 9999,
                  background: "white",
                  maxHeight:
                    window.innerWidth >= 320 && window.innerWidth <= 374
                      ? "300px"
                      : "650px",
                  boxShadow:
                    "0 2px 4px rgba(0, 0, 0, 0.2), 0 6px 10px rgba(0, 0, 0, 0.25) , 0 12px 20px rgba(0, 0, 0, 0.3)",
                }}
                onCancel={() => {
                  setDrawerOpenone(false);
                  setLocationDetialsProps(tripDetails);
                  setRouteDetails([]);
                }}
              >
                {tripPopupOpen ? (
                  <>
                    <Drawer
                      style={{
                        marginTop: "130px",
                        width: "400px",
                        marginRight: "850px",
                        top: "47px",
                        left: "260px",
                        borderRadius: "20px",
                        height: "650px",
                        overflowY: "scroll",
                        padding: "20px",
                      }}
                      onCancel={() => setDrawerOpenone(false)}
                    >
                      <Row gutter={16}>
                        <Col xl={24}>
                          <div className="container_eight">
                            <Lefticon onClick={() => setTripPopupOpen(false)} />

                            <div>
                              {" "}
                              <p
                                className="mb-0"
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "500",
                                  color: "#1F243B",
                                }}
                              >
                                Back to Trips
                              </p>{" "}
                            </div>
                          </div>

                          <div className="container_eight">
                            <p className="Consignment_p">
                              Consignment: #{singleConsignor?.CONSIGNID}
                            </p>
                          </div>

                          <hr className="mt-0" />
                        </Col>
                        <Newbox>
                          <Col xl={24}>
                            <div>
                              <Tabs defaultActiveKey="1">
                                {tabItemsOne.map((tab) => (
                                  <Tabs.TabPane tab={tab.label} key={tab.key}>
                                    {tab.content}
                                  </Tabs.TabPane>
                                ))}
                              </Tabs>
                            </div>
                          </Col>
                        </Newbox>
                      </Row>
                    </Drawer>
                  </>
                ) : (
                  <>
                    <Newbox className="">
                      <HomeContainer>
                        <Row className="trip_drawer" gutter={16}>
                          <Col xl={24}>
                            <DrawerHeader style={{}}>
                              <div className="trip_wrapper">
                                <h4 className="trip_heading">Trips</h4>
                                <div className="trip_content">
                                  <div className="search-container">
                                    <span
                                      className="search-container_trips"
                                      style={{
                                        position: "absolute",
                                        left: 80,
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        color: "#888",
                                        pointerEvents: "none",
                                        zIndex: 9999,
                                      }}
                                    >
                                      <Search
                                        className="svg_search"
                                        style={{
                                          fontSize: 18,
                                          marginLeft: "45px",
                                          marginBottom: "22px",
                                        }}
                                      />
                                    </span>
                                    <SearchInput
                                      className="search-input"
                                      type="text"
                                      style={{ paddingLeft: 36 }}
                                      placeholder="Search"
                                      onChange={(e) =>
                                        setSearchTerm(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </DrawerHeader>
                          </Col>
                          <Col xl={24}>
                            <Tabs
                              defaultActiveKey="1"
                              onTabClick={(key) => {
                                setTabId(key);
                              }}
                            >
                              {tabItems.map((tab) => (
                                <Tabs.TabPane tab={tab.label} key={tab.key}>
                                  {tab.content}
                                </Tabs.TabPane>
                              ))}
                            </Tabs>
                          </Col>
                        </Row>
                      </HomeContainer>
                    </Newbox>
                  </>
                )}
              </Drawer>
            }
          </Newbox>
        </HomeContainer>
      )}

      {containerTruck && (
        <>
          {vehicles ? (
            <>
              <Newbox>
                <Drawer
                  ref={drawerRef}
                  style={{
                    marginTop: "120px",
                    width: "380px",
                    marginRight: "100px",
                    borderRadius: "20px",
                    height: "650px",
                    padding: "6px 6px 15px 15px ",
                    overflowY: "scroll",
                    zIndex: 9999,
                  }}
                  onCancel={() => setContainerTruck(false)}
                >
                  <Row gutter={16}>
                    <Col xl={24}>
                      <div className="container_forvehicles">
                        <Lefticon onClick={clickiconvechilefunc} />
                        <p> Back to Vehicles</p>
                      </div>
                      <div className="container_forvehicles">
                        <p> Vehicle: KC12345</p>
                      </div>
                      <hr />
                      <div>
                        <Tabs
                          defaultActiveKey="Details"
                          items={tabItemsthree.map((tab) => ({
                            key: tab.key,
                            label: tab.label,
                            children: tab.content,
                          }))}
                        />
                      </div>
                    </Col>
                  </Row>
                </Drawer>
              </Newbox>
            </>
          ) : (
            <>
              <Newbox>
                <Drawer
                  ref={drawerRef}
                  className="drawerfor_vehicles"
                  style={{
                    marginTop: "120px",
                    width: "400px",
                    marginRight: "100px",
                    borderRadius: "20px",
                    height: "650px",
                    padding: "15px",
                    overflowY: "scroll",
                    zIndex: 9999,
                  }}
                  onCancel={() => setContainerTruck(false)}
                >
                  <Row gutter={16}>
                    <Col xl={24}>
                      <DrawerHeader>
                        <div
                          className="conatiner_drawer_header"
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <h4 style={{ marginBottom: "20px" }}>Vehicles</h4>

                          <CiSearch
                            className="search_input"
                            style={{
                              position: "absolute",
                              left: "130px",
                              top: "13px",
                              fontSize: "18px", // You can adjust the size here
                              color: "#888", // Optional: Change the icon color
                            }}
                          />
                          <SearchInput
                            className="Inputval_field"
                            style={{
                              marginLeft: "30px",
                              paddingLeft: "25px",
                              border: "1px solid gray",
                              width: "200px",
                            }}
                            type="text"
                            placeholder="Search"
                            onChange={(e) => setVehicleSearch(e.target.value)}
                          />
                        </div>

                        <DrawercloseIcon
                          className="close_btnfordrawer"
                          onClick={vehiclecontainerpopupfunc}
                        />
                      </DrawerHeader>
                    </Col>
                    <Col xl={24}>
                      <Tabs
                        defaultActiveKey="assign"
                        onChange={(key) => console.log("Active Tab:", key)}
                      >
                        {tabItemstwo.map((tab) => (
                          <Tabs.TabPane tab={tab.label} key={tab.key}>
                            {tab.content}
                          </Tabs.TabPane>
                        ))}
                      </Tabs>
                    </Col>
                  </Row>
                </Drawer>
              </Newbox>
            </>
          )}
        </>
      )}
      <Modal
        title="Samuvel Josaph"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        okText="Send"
        cancelText="Close"
      >
        <Input.TextArea
          className="msg"
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message here..."
        />
      </Modal>
      <Modal
        open={isModalOpen}
        closable={false}
        onCancel={() => {
          setIsModalOpen(false); // Close the modal when clicking outside or pressing ESC
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsModalOpen(false); // Close the modal
            }}
            className="cancel-btn"
            style={{
              borderRadius: "26px",
              backgroundColor: "#E8FFEC",
              color: "#2C963D",
              borderColor: "#E8FFEC",
              width: "118px",
              height: "38px",
            }}
          >
            Cancel
          </Button>,
          <ButtonFilled
            key="clear"
            onClick={() => {
              setIsModalOpen(false);
              form.resetFields();
              setFilterCount(0);
              setFormValues({});
            }}
            className="and_clear_btn"
            type="primary"
          >
            Clear All
          </ButtonFilled>,
        ]}
        width={1000}
      >
        <Newbox>
          <Row>
            <Col xl={24} xs={{ span: 24, order: 2 }}>
              <div className="container_for_kpi_filter">
                <p className="Filter_for_clickablerow">
                  Filter ({filterCount})
                </p>
                {/* <p className="Filter_for_Result">4 Result Found </p> */}
              </div>
            </Col>
          </Row>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(value, allvalues) => {
              getFilterCount();
              setFormValues(allvalues);
            }}
          >
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Trip Type" name="tripType">
                  <Select className="w-100" showSearch allowClear>
                    <Option value={2}>Safari</Option>
                    <Option value={1}>Local</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Consignor" name="consignor">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consignerList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Transporter" name="transporter">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={transporterList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Vehicle" name="vehicle">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={vehicleOptions}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Date" name="date">
                  <DatePicker className="w-100" />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Shipment Type" name="shipment">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={
                      selectedReport === "TrackRightAI" ||
                      selectedReport === "TrackrightAIPlus"
                        ? shipmentType.map((item) => ({
                            label: item.name,
                            value: item.value,
                          }))
                        : selectedReport === "ContainerTracking"
                          ? ShipmentType.map((item) => ({
                              label: item.name,
                              value: item.value,
                            }))
                          : []
                    }
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Newbox>
      </Modal>
    </>
  );
};

export default Home;
